<!-- CASE MODULES TABLE -->
<!-- <ng-container>
    <div class="flex-100 flex-row align-end-center header-buttons p-1" style="height: 36px;"> -->
<div class="flex-column flex-100 mbs-2">
    <div class="flex-100 flex-row align-end-center header-buttons" style="height: 36px;">
        <!-- Add provision -->
        <button mat-icon-button [matTooltip]="'Agregar módulo'" [color]="'primary'" id="addArrangementButton"
            (click)="openAddModuleDialog()">
            <mat-icon>add_circle_outlined</mat-icon>
        </button>

        <button mat-icon-button (click)="$event.stopPropagation()" matTooltip="Acciones"
            [matMenuTriggerFor]="caseModuleCreationMenuActions" [matMenuTriggerData]="{}">
            <mat-icon class="cursor-pointer text-secondary"
                [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'"></mat-icon>
        </button>
    </div>
    <div class="flex-100 pxs-1 flex-column" [style.overflow-x]="isCollapsed ? 'hidden' : null">

        <!---------------------------- Module Table------------------------------------------------>

        <table tabindex="0" mat-table class="modules-main-table" [class.modules-collapsed]="isCollapsed"
            style="width: 100%; border-radius: 10px;" [dataSource]="dataSource" multiTemplateDataRows>
            <ng-container matColumnDef="module">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
                    <span class="flex align-start-center mls-2">Módulo</span>
                </th>
                <td mat-cell *matCellDef="let data">
                    <div class="flex-row border-none width-100 align-start-center"
                        [ngStyle]="{ 'max-width': !isExpanded ? '5rem' : '' }">
                        <button mat-icon-button (click)="$event.stopPropagation(); toggleRow(data)">
                            <mat-icon color="primary">
                                {{ data === expandedElement ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                            </mat-icon>
                        </button>
                        <span class="subtitle-3 text-primary-darker text-ellipsis" style="text-align: start;">
                            {{ data.name }}
                        </span>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- masterCheck -->
            <ng-container matColumnDef="modulesMasterCheck">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
                    <div class="align-center-center">
                        <!-- <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? masterToggle() : null"
                            [checked]="selectionModules.hasValue() && isAllSelected()"
                            [indeterminate]="selectionModules.hasValue() && !isAllSelected()">
                        </mat-checkbox> -->
                    </div>
                </th>
                <td mat-cell *matCellDef="let row" style="min-width: 0px !important; padding-right: 10px !important;">
                    <div class="align-center-center">
                        @if(singleSelectionMode) {
                        <mat-radio-button (click)="$event.stopPropagation()" (change)="selectModuleSingle(row)"
                            [checked]="singleSelectedModuleId === row.id">
                        </mat-radio-button>
                        } @else {
                        <mat-checkbox (click)="$event.stopPropagation()" (change)="selectModule(row)"
                            [checked]="isModuleSelected(row)">
                        </mat-checkbox>
                        }
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Frequency -->
            <ng-container matColumnDef="moduleFrequency">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
                    Frecuencia
                </th>
                <td mat-cell *matCellDef="let data">
                    <div class="border-none width-100" [ngStyle]="{ 'max-width': !isExpanded ? '5rem' : '' }">
                        <span class="text-ellipsis">
                            {{data.frequency}}
                        </span>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Fee -->
            <ng-container matColumnDef="moduleFee">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
                    <div class="flex-column align-center-center">
                        <span>Valor</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let row" style="width: 5rem;">
                    <span>$ {{ row.fee }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Total Scheduled -->
            <ng-container matColumnDef="modulesTotalScheduledCount">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
                    <div class="flex-column align-center-center">
                        <span>Total Agendado</span>
                    </div>
                </th>
                <td mat-cell *matCellDef="let module" style="width:6rem;">
                    <span>{{ totalOfModule(module) }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- States-Group-->
            <ng-container matColumnDef="modulesStates">
                <th mat-header-cell *matHeaderCellDef [attr.colspan]="modulesStatesColumns.length">
                    Estados
                </th>
                <td mat-cell class="display-none" *matCellDef></td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Billable -->
            <ng-container matColumnDef="billingModulesCount">
                <th mat-header-cell *matHeaderCellDef style="padding:0;">
                    <div style="
                    border: 1px solid #d7d0e8;
                    border-radius: 10px 0 0 0;
                    border-right: none;
                    width: 100%;
                    height: 3rem;;
                    box-sizing: border-box;
                    display:flex; align-items:center; justify-content:center;
                  ">
                        Fact.
                    </div>
                </th>
                <td mat-cell *matCellDef="let c">{{ invoicedOfModule(c) }}</td>
            </ng-container>

            <!-- Debited -->
            <ng-container matColumnDef="debitedModulesCount">
                <th mat-header-cell *matHeaderCellDef style="padding:0;">
                    <div style="
                    border: 1px solid #d7d0e8;
                    border-left: none;
                    border-right: none;
                    width: 100%;
                    height: 3rem;
                    box-sizing: border-box;
                    display:flex; align-items:center; justify-content:center;
                  ">Deb.</div>
                </th>
                <td mat-cell *matCellDef="let c">{{ debitedOfModule(c) }}</td>
            </ng-container>

            <!-- Informed -->
            <ng-container matColumnDef="informedModulesCount">
                <th mat-header-cell *matHeaderCellDef style="padding:0;">
                    <div style="
                    border: 1px solid #d7d0e8;
                    border-radius: 0 10px 0 0;
                    border-left: none;
                    width: 100%;
                    height: 3rem;
                    box-sizing: border-box;
                    display:flex; align-items:center; justify-content:center;
                  ">Infor.</div>
                </th>
                <td mat-cell *matCellDef="let c">{{ fullyDeliveredOfModule(c) }}</td>
            </ng-container>

            <!-- Vigency -->
            <ng-container matColumnDef="moduleVigency">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Vigencia</th>
                <td mat-cell *matCellDef="let module" style="width:6rem;">
                    <span>{{ module.vigency || '-' }}</span>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Autorization -->
            <ng-container matColumnDef="moduleAutorization">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Autoriz.</th>
                <td mat-cell *matCellDef="let module" style="width:6rem;">
                    <div class="module-state-cell">
                        <mat-chip-listbox>
                            <mat-chip [ngStyle]="{
                                        'background-color': this.getBackgroundColorAuthorizationState(module),
                                        color: this.getColorAuthorizationState(module)
                                    }" matTooltip="{{
                                            module.authorization
                                            ? '#' + module.authorization.authorizationNumber + ' - ' + this.generalService.getAuthorizationState(module.authorization)
                                            : this.generalService.getAuthorizationState(module.authorization)
                                    }}" (click)="this.onClickAuthorization(module); $event.stopPropagation()"
                                matBadge="P" [matBadgeHidden]="module.arrangementId" matBadgeColor="accent"
                                matBadgeSize="small">
                                <span class="mat-small cursor-pointer">
                                    {{ this.generalService.getAuthorizationState(module.authorization) |
                                    firstLetterWordsIntoString }}
                                </span>
                            </mat-chip>
                        </mat-chip-listbox>
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="moduleActions">
                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2"></th>
                <td mat-cell *matCellDef="let module" style="min-width: 1rem !important;">
                    <button mat-icon-button (click)="$event.stopPropagation()" matTooltip="Acciones"
                        [matMenuTriggerFor]="caseModuleMenuActions" [matMenuTriggerData]="{ cm: module }">
                        <mat-icon class="cursor-pointer text-secondary"
                            [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'"></mat-icon>
                    </button>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Header separator row -->
            <ng-container matColumnDef="progressBarModules">
                <th mat-header-cell *matHeaderCellDef [attr.colspan]="activeModulesRowColumns.length"
                    class="padding:0 !important">
                    <div class="modules-header-separator"></div>
                </th>
            </ng-container>

            <!--(Provisions (Practices & Supplies) Detail) -->
            <ng-container matColumnDef="provisionsDetail">
                <td mat-cell *matCellDef="let row" class="" [attr.colspan]="activeModulesRowColumns.length">
                    <div class="modules-expand-detail"
                        [@detailExpand]="expandedElement === row ? 'expanded' : 'collapsed'">

                        <!-- ======================== PRACTICES (row.provisions where isSupply = false) ======================== -->
                        <table mat-table [dataSource]="getPracticesTableData(row)" class="provisions-table"
                            multiTemplateDataRows>

                            <!-- Code -->
                            <ng-container matColumnDef="provisionCode">
                                <th colspan="2" mat-header-cell *matHeaderCellDef [attr.rowspan]="2"
                                    style="text-align: start !important">
                                    <span class="mls-2">Práctica</span>
                                </th>
                                <td mat-cell *matCellDef="let c">
                                    {{
                                    c.practice?.code ||
                                    c.practice?.nomenclatorCode ||
                                    c.practiceId ||
                                    c.practice?.id ||
                                    '-'
                                    }}
                                </td>
                            </ng-container>

                            <!-- Practice -->
                            <ng-container matColumnDef="provisionName">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2" style="display:none"></th>
                                <td mat-cell *matCellDef="let c">
                                    <div class="flex-row align-start-center width-100">
                                        <!-- expand/collapse arrow -->
                                        <button mat-icon-button class="mrs-1"
                                            (click)="$event.stopPropagation(); toggleChildRow(c)"
                                            aria-label="Expand practice">
                                            <mat-icon color="primary">
                                                {{ expandedChild === c ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
                                                }}
                                            </mat-icon>
                                        </button>

                                        <span class="cell-ellipsis" style="max-width: 10rem !important;"
                                            [matTooltip]="c.practice?.name || c.practice?.description || '-'">
                                            {{ c.practice?.name || c.practice?.description || '-' }}
                                        </span>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Checkbox -->
                            <ng-container matColumnDef="provisionsMasterCheck">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        [checked]="isAllPracticesRowsSelected(row)"
                                        [indeterminate]="isSomePracticesRowsSelected(row)"
                                        [disabled]="singleSelectionMode && singleSelectedModuleId !== row.id"
                                        (change)="toggleAllPracticesRows(row, $event.checked)">
                                    </mat-checkbox>
                                </th>

                                <td mat-cell *matCellDef="let c">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        [checked]="isPracticeRowSelected(row, c)"
                                        [disabled]="singleSelectionMode && singleSelectedModuleId !== row.id"
                                        (change)="togglePracticeRow(row, c, $event.checked)">
                                    </mat-checkbox>
                                </td>
                            </ng-container>

                            <!-- Frequency -->
                            <ng-container matColumnDef="provisionFrequency">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Frecuencia</th>
                                <td mat-cell *matCellDef="let c">
                                    {{ getProvisionFrequencyLabel(c) }}
                                </td>
                            </ng-container>

                            <!-- TotalScheduled -->
                            <ng-container matColumnDef="provisionTotalScheduled">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Total Agendado</th>
                                <td mat-cell *matCellDef="let c">{{ totalOfProvision(c, c.provisionFees?.[0]) }}</td>
                            </ng-container>

                            <!-- States-Group-->
                            <ng-container matColumnDef="provisionStates">
                                <th mat-header-cell *matHeaderCellDef [attr.colspan]="provisionsStatesColumns.length"
                                    class="align-center-center">
                                    Estados
                                </th>
                                <td mat-cell class="display-none" *matCellDef="let c"></td>
                            </ng-container>

                            <!-- Realized -->
                            <ng-container matColumnDef="realizedProvisionsCount">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div style="
                                    border: 1px solid #d7d0e8;
                                    border-radius: 10px 0 0 0;
                                    border-right: none;
                                    width: 100%;
                                    height: 3rem;;
                                    box-sizing: border-box;
                                    display:flex; align-items:center; justify-content:center;
                                  ">Realizado
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let c">{{ totalRealizedOfProvision(c,c.provisionFees[0]) }}
                                </td>
                            </ng-container>

                            <!-- Billable -->
                            <ng-container matColumnDef="billingProvisionsCount">
                                <th mat-header-cell *matHeaderCellDef class="estado-col estado-group-mid">
                                    <div style="
                                    border: 1px solid #d7d0e8;
                                    border-left: none;
                                    border-right: none;
                                    width: 100%;
                                    height: 3rem;
                                    box-sizing: border-box;
                                    display:flex; align-items:center; justify-content:center;
                                  ">Facturable</div>
                                </th>
                                <td mat-cell *matCellDef="let c">{{ invoicedOfProvision(c,c.provisionFees[0]) }}</td>
                            </ng-container>

                            <!-- Debited -->
                            <ng-container matColumnDef="debitedProvisionsCount">
                                <th mat-header-cell *matHeaderCellDef class="estado-col estado-group-mid">
                                    <div style="
                                    border: 1px solid #d7d0e8;
                                    border-left: none;
                                    border-right: none;
                                    width: 100%;
                                    height: 3rem;
                                    box-sizing: border-box;
                                    display:flex; align-items:center; justify-content:center;
                                  ">Debitable</div>
                                </th>
                                <td mat-cell *matCellDef="let c">{{debitedOfProvision(c,c.provisionFees[0]) }}</td>
                            </ng-container>

                            <!-- Informed -->
                            <ng-container matColumnDef="informedProvisionsCount">
                                <th mat-header-cell *matHeaderCellDef class="estado-col estado-group-end">
                                    <div style="
                                    border: 1px solid #d7d0e8;
                                    border-radius: 0 10px 0 0;
                                    border-left: none;
                                    width: 100%;
                                    height: 3rem;
                                    box-sizing: border-box;
                                    display:flex; align-items:center; justify-content:center;
                                  ">
                                        Informado</div>
                                </th>
                                <td mat-cell *matCellDef="let c">{{ fullyDeliveredOfProvision(c,c.provisionFees[0]) }}
                                </td>
                            </ng-container>

                            <!-- + Btn / Actions -->
                            <ng-container matColumnDef="addProvision">
                                <th mat-header-cell *matHeaderCellDef class="child-add-header" [attr.rowspan]="2">
                                    <button mat-icon-button [matTooltip]="'Agregar práctica'" [color]="'primary'"
                                        (click)="$event.stopPropagation(); openPracticesPickerForCaseModule(row)"
                                        id="addArrangementButton">
                                        <mat-icon>add_circle_outlined</mat-icon>
                                    </button>
                                </th>
                                <td mat-cell *matCellDef="let c">
                                    <button mat-icon-button (click)="$event.stopPropagation()" matTooltip="Acciones"
                                        [matMenuTriggerFor]="caseModuleProvisionsMenuActions"
                                        [matMenuTriggerData]="{ provision: c, cm: row }">
                                        <mat-icon class="cursor-pointer text-secondary"
                                            [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'"></mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <!-- ======================== AGREEMENTS (child.agreements) ======================== -->
                            <ng-container matColumnDef="childExpandedDetail">
                                <td mat-cell *matCellDef="let child" class="child-detail-cell"
                                    [attr.colspan]="activeProvisionsRowColumns.length">
                                    <div class="grand-wrap"
                                        [@detailExpand]="expandedChild === child ? 'expanded' : 'collapsed'">
                                        <div class="shadow"></div>
                                        <table mat-table class="grand-table full-width"
                                            [dataSource]="getVisibleAgreementsForProvision(child)">

                                            <!-- agreement -->
                                            <ng-container matColumnDef="agreement">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <span class="subtitle-3 text-primary">Acuerdo prestacional</span>
                                                </th>
                                                <td mat-cell *matCellDef="let r" class="flex-row gap-0-5em"
                                                    style="height: 4rem;">
                                                    <mat-checkbox (click)="$event.stopPropagation()"
                                                        [checked]="isAgreementRowSelected(row, child, r)"
                                                        [disabled]="!isPracticeRowSelected(row, child)"
                                                        (change)="toggleAgreementRow(row, child, r, $event.checked)"
                                                        class="flex-20"></mat-checkbox>
                                                    <span class="flex-80">
                                                        <ng-container *ngIf="r.provider as p; else noProvider">
                                                            {{ p.fullName || (p.name + ' ' + p.surname) }}
                                                        </ng-container>
                                                        <ng-template #noProvider>Sin prestador</ng-template>
                                                    </span>
                                                </td>
                                            </ng-container>

                                            <!-- totalScheduled -->
                                            <ng-container matColumnDef="agreementsTotalScheduledCount">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <span class="subtitle-3 text-primary">Total agendado</span>
                                                </th>
                                                <td mat-cell *matCellDef="let r">{{ agreementTotal(child,r) }}</td>
                                            </ng-container>

                                            <!-- fee -->
                                            <ng-container matColumnDef="agreementCost">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <span class="subtitle-3 text-primary">Costo</span>
                                                </th>
                                                <td mat-cell *matCellDef="let r">${{ (r.providerFee ?? 0) }}
                                                </td>
                                            </ng-container>

                                            <!-- done -->
                                            <ng-container matColumnDef="doneAgreementsCount">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <span class="subtitle-3 text-primary">Realizadas</span>
                                                </th>
                                                <td mat-cell *matCellDef="let r">{{ agreementPerformed(child,r)}}</td>
                                            </ng-container>

                                            <!-- notDone -->
                                            <ng-container matColumnDef="notDoneAgreementsCount">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <span class="subtitle-3 text-primary">No realizadas</span>
                                                </th>
                                                <td mat-cell *matCellDef="let r">{{ agreementNotPerformed(child,r) }}
                                                </td>
                                            </ng-container>

                                            <!-- billable -->
                                            <ng-container matColumnDef="billableAgreementsCount">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <span class="subtitle-3 text-primary">Facturables</span>
                                                </th>
                                                <td mat-cell *matCellDef="let r">{{ agreementInvoiced(child,r) }}</td>
                                            </ng-container>

                                            <!-- debitable -->
                                            <ng-container matColumnDef="debitableAgreementsCount">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <span class="subtitle-3 text-primary">Debitables</span>
                                                </th>
                                                <td mat-cell *matCellDef="let r">{{agreementDebited(child,r) }}</td>
                                            </ng-container>

                                            <!-- reported -->
                                            <ng-container matColumnDef="reportedAgreementsCount">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <span class="subtitle-3 text-primary">Informadas</span>
                                                </th>
                                                <td mat-cell *matCellDef="let r">{{ agreementInformed(child,r) }}</td>
                                            </ng-container>

                                            <!-- vigency -->
                                            <ng-container matColumnDef="agreementVigency">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <span class="subtitle-3 text-primary">Vigencia</span>
                                                </th>
                                                <td mat-cell *matCellDef="let r">
                                                    {{ r.fromDate ? (r.fromDate | date:'dd/MM/yyyy') : '-' }}
                                                    -
                                                    {{ r.toDate ? (r.toDate | date:'dd/MM/yyyy') : 'en adelante' }}
                                                </td>
                                            </ng-container>

                                            <!-- grandActions -->
                                            <ng-container matColumnDef="agreementActions">
                                                <th mat-header-cell *matHeaderCellDef>
                                                    <button mat-icon-button
                                                        [matTooltip]="'Agregar acuerdo prestacional'"
                                                        [color]="'primary'"
                                                        (click)="$event.stopPropagation(); openAddAgreementDialogFromExpandedChild()"
                                                        id="addAgreementButton">
                                                        <mat-icon>add_circle_outlined</mat-icon>
                                                    </button>
                                                </th>
                                                <td mat-cell *matCellDef="let r">
                                                    <button mat-icon-button (click)="$event.stopPropagation()"
                                                        matTooltip="Acciones"
                                                        [matMenuTriggerFor]="caseModuleAgreementsMenuActions"
                                                        [matMenuTriggerData]="{ provision: child, agreement: r }">
                                                        <mat-icon class="cursor-pointer text-secondary"
                                                            [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'">
                                                        </mat-icon>
                                                    </button>
                                                </td>
                                            </ng-container>

                                            <tr mat-header-row *matHeaderRowDef="activeAgreementsColumns"
                                                style="background-color: rgb(230, 230, 230, 1) !important;"></tr>
                                            <tr mat-row *matRowDef="let r; columns: activeAgreementsColumns"></tr>
                                        </table>
                                        <div class="shadow-bottom"></div>

                                    </div>
                                </td>
                            </ng-container>

                            <!-- Header rows -->
                            <tr mat-header-row *matHeaderRowDef="activeProvisionsHeaderColumns" class="child-header"
                                style="height: 2rem;"></tr>
                            <tr mat-header-row *matHeaderRowDef="isCollapsed ? null : provisionsStatesColumns"
                                class="child-states-header" style="height: 2rem;"></tr>

                            <!-- Data rows (solo prácticas: el datasource ya viene filtrado) -->
                            <tr mat-row *matRowDef="let c; columns: activeProvisionsRowColumns" class="child-data-row"
                                [class.child-data-row--expanded]="expandedChild === c" (click)="toggleChildRow(c)"></tr>

                            <!-- Detail row (solo para la fila expandida) -->
                            <tr mat-row *matRowDef="let c; columns: ['childExpandedDetail']" class="child-detail-row">
                            </tr>

                        </table>

                        <!-- ======================== SUPPLIES (row.provisions where isSupply = true) ======================== -->
                        <!-- ===== SUPPLIES (agrupados por tipo: Descartables/Medicamentos/Equipamientos/Otros) ===== -->
                        <table mat-table [dataSource]="getSuppliesGroupedTableData(row)" class="provisions-table"
                            *ngIf="!hideSuppliesSection" multiTemplateDataRows>

                            <!-- Supply Code -->
                            <ng-container matColumnDef="supplyCode">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2" colspan="2"
                                    style="text-align: start !important;"><span class="mls-2">Insumo</span></th>

                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyGroupRow(0, r); else supplyCodeItem">
                                        <div class="supply-group-cell">
                                            <button mat-icon-button type="button" (click)="$event.stopPropagation();
                                                toggleSupplyGroup(row, r)">
                                                <mat-icon>
                                                    {{ isSupplyGroupExpanded(row, r) ? 'keyboard_arrow_down' :
                                                    'keyboard_arrow_right' }}
                                                </mat-icon>
                                            </button>
                                        </div>
                                    </ng-container>

                                    <ng-template #supplyCodeItem>
                                        {{
                                        r.practice?.code ||
                                        r.practice?.nomenclatorCode ||
                                        r.practiceId ||
                                        r.practice?.id ||
                                        '-'
                                        }}
                                    </ng-template>
                                </td>
                            </ng-container>

                            <!-- Supply Name / Group label -->
                            <ng-container matColumnDef="supplyName">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2" style="display:none"></th>

                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyGroupRow(0, r); else supplyNameItem">
                                        <div class="supply-group-cell">
                                            <span class="supply-group-label">{{ getSupplyGroupLabel(row, r) }}</span>
                                        </div>
                                    </ng-container>

                                    <ng-template #supplyNameItem>
                                        <span class="cell-ellipsis pls-2" style="max-width:max-content !important;"
                                            [matTooltip]="r.practice?.name || r.practice?.description || '-'"> {{
                                            r.practice?.name || r.practice?.description || '-' }}</span>
                                    </ng-template>
                                </td>
                            </ng-container>

                            <!-- Master Check -->
                            <ng-container matColumnDef="supplyMasterCheck">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        [checked]="isAllSuppliesRowsSelected(row)"
                                        [indeterminate]="isSomeSuppliesRowsSelected(row)"
                                        (change)="toggleAllSuppliesRows(row, $event.checked)">
                                    </mat-checkbox>
                                </th>

                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyGroupRow(0, r); else supplyRowCheck">
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                            [disabled]="getSuppliesByCategory(row, r).length === 0"
                                            [checked]="isAllSuppliesRowsSelectedByCategory(row, r)"
                                            [indeterminate]="isSomeSuppliesRowsSelectedByCategory(row, r)"
                                            (change)="toggleAllSuppliesRowsByCategory(row, r, $event.checked)">
                                        </mat-checkbox>
                                    </ng-container>

                                    <ng-template #supplyRowCheck>
                                        <mat-checkbox (click)="$event.stopPropagation()"
                                            [checked]="isSupplyRowSelected(row, r)"
                                            (change)="toggleSupplyRow(row, r, $event.checked)">
                                        </mat-checkbox>
                                    </ng-template>
                                </td>
                            </ng-container>

                            <!-- Quantity -->
                            <ng-container matColumnDef="supplyQuantity">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Cantidad</th>
                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyItemRow(0, r)">
                                        {{ getSupplyQuantityLabel(r) }}
                                    </ng-container>
                                </td>
                            </ng-container>

                            <!-- Vendor -->
                            <ng-container matColumnDef="supplyVendor">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Proveedor</th>
                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyItemRow(0, r)">
                                        {{ getSupplyVendorLabel(r) }}
                                    </ng-container>
                                </td>
                            </ng-container>

                            <!-- Total Cost -->
                            <ng-container matColumnDef="supplyTotalCost">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Costo Total</th>
                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyItemRow(0, r)">
                                        {{getSupplyTotalFee(r)}}
                                    </ng-container>
                                </td>
                            </ng-container>

                            <!-- Ordered -->
                            <ng-container matColumnDef="supplyOrdered">
                                <th mat-header-cell *matHeaderCellDef [attr.rowspan]="2">Pedido</th>
                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyItemRow(0, r)">
                                        {{ getSupplyOrderedCount(r.provisionFees[0]) }}
                                    </ng-container>
                                </td>
                            </ng-container>

                            <!-- States group header -->
                            <ng-container matColumnDef="suppliesStates">
                                <th mat-header-cell *matHeaderCellDef [attr.colspan]="suppliesStatesColumns.length"
                                    class="align-center-center">
                                    Estados
                                </th>
                                <td mat-cell class="display-none" *matCellDef="let r"></td>
                            </ng-container>

                            <!-- ===== States columns ===== -->

                            <ng-container matColumnDef="deliveredSuppliesCount">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div
                                        style="border:1px solid #d7d0e8;border-radius:10px 0 0 0;border-right:none;width:100%;height:3rem;display:flex;align-items:center;justify-content:center;">
                                        Entr.
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyItemRow(0, r)">
                                        {{ getDelivered(r.provisionFees[0]) }}
                                    </ng-container>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="notDeliveredSuppliesCount">
                                <th mat-header-cell *matHeaderCellDef class="estado-col estado-group-mid">
                                    <div
                                        style="border:1px solid #d7d0e8;border-left:none;border-right:none;width:100%;height:3rem;display:flex;align-items:center;justify-content:center;">
                                        No en.
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyItemRow(0, r)">
                                        {{ getNotDelivered(r.provisionFees[0]) }}
                                    </ng-container>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="billedSuppliesCount">
                                <th mat-header-cell *matHeaderCellDef class="estado-col estado-group-mid">
                                    <div
                                        style="border:1px solid #d7d0e8;border-left:none;border-right:none;width:100%;height:3rem;display:flex;align-items:center;justify-content:center;">
                                        Fact.
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyItemRow(0, r)">
                                        {{ getInvoiced(r.provisionFees[0]) }}
                                    </ng-container>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="billableSuppliesCount">
                                <th mat-header-cell *matHeaderCellDef class="estado-col estado-group-mid">
                                    <div
                                        style="border:1px solid #d7d0e8;border-left:none;border-right:none;width:100%;height:3rem;display:flex;align-items:center;justify-content:center;">
                                        Deb.
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyItemRow(0, r)">
                                        {{ getDebited(r.provisionFees[0]) }}
                                    </ng-container>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="informedSuppliesCount">
                                <th mat-header-cell *matHeaderCellDef class="estado-col estado-group-end">
                                    <div style="
                                    border: 1px solid #d7d0e8;
                                    border-radius: 0 10px 0 0;
                                    border-left: none;
                                    width: 100%;
                                    height: 3rem;
                                    box-sizing: border-box;
                                    display:flex; align-items:center; justify-content:center;
                                  ">
                                        Infor.
                                    </div>
                                </th>
                                <td mat-cell *matCellDef="let r">
                                    <ng-container *ngIf="isSupplyItemRow(0, r)">
                                        {{ getInformed(r.provisionFees[0]) }}
                                    </ng-container>
                                </td>
                            </ng-container>

                            <!-- Actions -->
                            <ng-container matColumnDef="supplyActions">
                                <th mat-header-cell *matHeaderCellDef
                                    style="width: 7rem !important; max-width: 7rem !important;" [attr.rowspan]="2">
                                    <button mat-icon-button [matTooltip]="'Agregar insumo'" [color]="'primary'"
                                        (click)="$event.stopPropagation(); openSuppliesPickerForCaseModule(row)">
                                        <mat-icon>add_circle_outlined</mat-icon>
                                    </button>

                                    <button mat-icon-button (click)="$event.stopPropagation()" matTooltip="Acciones"
                                        [matMenuTriggerFor]="caseModuleSuppliesMenuActions"
                                        [matMenuTriggerData]="{ cm: row }">
                                        <mat-icon class="cursor-pointer text-secondary"
                                            [svgIcon]="'DotsThreeVertical-enabled-primary-lighter'"></mat-icon>
                                    </button>
                                </th>

                                <td mat-cell *matCellDef="let r">

                                </td>
                            </ng-container>

                            <!-- Header rows -->
                            <tr mat-header-row *matHeaderRowDef="activeSuppliesHeaderColumns" class="child-header"
                                style="height: 2rem;"></tr>
                            <tr mat-header-row *matHeaderRowDef="suppliesStatesColumns" class="child-states-header"
                                style="height: 2rem;" [hidden]="isCollapsed"></tr>

                            <!-- Data rows -->
                            <tr mat-row *matRowDef="let r; columns: activeSuppliesRowColumns; when: isSupplyGroupRow"
                                class="child-data-row cursor-pointer"
                                style="background-color: rgb(230, 230, 230, 1) !important"
                                (click)="toggleSupplyGroup(row, r)"></tr>

                            <tr mat-row *matRowDef="let r; columns: activeSuppliesRowColumns; when: isSupplyItemRow"
                                class="child-data-row supply-item-row"
                                [ngClass]="{ 'create-order-error-row': isCreateOrderErrorSupplyRow(r) }"></tr>

                        </table>

                    </div>
                </td>
            </ng-container>

            <!-- ===== Modules footer (single full-width cell) ===== -->
            <ng-container matColumnDef="modulesFooter">
                <td mat-footer-cell *matFooterCellDef [attr.colspan]="activeModulesRowColumns.length"
                    class="modules-footer-cell">
                    <div class="modules-footer pxs-5">
                        <div class="modules-footer__item">
                            <span class="modules-footer__label">MÓDULOS</span>
                            <span class="modules-footer__value">{{ modulesFooterSummary.modulesCount }}</span>
                        </div>

                        <div class="modules-footer__item">
                            <span class="modules-footer__label">TOTAL AGENDADO:</span>
                            <span class="modules-footer__value">{{ modulesFooterSummary.totalScheduledAmount | currency: 'ARS':'symbol':'1.2'
                                }}</span>
                        </div>

                        <div class="modules-footer__item">
                            <span class="modules-footer__label">TOTAL FACTURABLE:</span>
                            <span class="modules-footer__value">{{ modulesFooterSummary.totalBillableAmount | currency: 'ARS':'symbol':'1.2'
                                }}</span>
                        </div>

                        <div class="modules-footer__item">
                            <span class="modules-footer__label">TOTAL DEBITABLE:</span>
                            <span class="modules-footer__value">{{ modulesFooterSummary.totalDebitableAmount | currency: 'ARS':'symbol':'1.2'
                                }}</span>
                        </div>

                        <div class="modules-footer__item">
                            <span class="modules-footer__label">TOTAL INFORMADO:</span>
                            <span class="modules-footer__value">{{ modulesFooterSummary.totalInformedAmount | currency: 'ARS':'symbol':'1.2'
                                }}</span>
                        </div>
                    </div>
                </td>
            </ng-container>

            <!-- HEADERs -->
            <tr mat-header-row *matHeaderRowDef="activeModulesHeaderColumns" style="height: 2rem;"></tr>
            <tr mat-header-row *matHeaderRowDef="isCollapsed ? null : modulesStatesColumns"
                style="height: 2rem;border-bottom: 10px solid darkblue;"></tr>
            <tr mat-header-row *matHeaderRowDef="isCollapsed ? null : ['progressBarModules']"
                class="modules-header-separator-row"></tr>
            <!-- ROWS -->
            <tr mat-row *matRowDef="let row; columns: activeModulesRowColumns;" class="modules-data-row cursor-pointer"
                style="background-color: #DAD2EB;" (click)="toggleRow(row)">
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['provisionsDetail'];" class="modules-detail-row"
                [class.modules-detail-row--expanded]="expandedElement === row"></tr>
            <tr mat-footer-row *matFooterRowDef="isCollapsed ? [] : modulesFooterColumns" class="modules-footer-row">
            </tr>
        </table>


        <div class="flex align-center-center mts-5">
            <div class="flex-column align-center-center">
                @if (!isCollapsed) {
                <button [disabled]="getSelectedSuppliesForCreateOrderCount() === 0 || createOrderButtonDisabled()"
                    mat-flat-button [color]="'primary'" (click)="openAddOrderDialog()"
                    matTooltip="Crear pedido con los insumos seleccionados">
                    <span *ngIf="!_isLoadingCreatingOrder">
                        CREAR PEDIDO
                    </span>
                    <mat-spinner *ngIf="_isLoadingCreatingOrder" color="accent" diameter="20"></mat-spinner>
                </button>

                @if (getSelectedSuppliesForCreateOrderCount() > 0 && createOrderButtonDisabled()) {
                <div class="flex-column mts-3">
                    <mat-error class="mls-3">No puede crear el pedido.</mat-error>
                    <ng-container *ngFor="let reason of getCreateOrderDisabledReasons()">
                        <mat-error class="mls-3">{{ reason }}</mat-error>
                    </ng-container>
                    <span class="text-primary mls-3" style="cursor:pointer;" (click)="rowsWithErrorsForCreateOrder()">
                        Resaltar insumo/s
                    </span>
                </div>
                }
                }
            </div>
        </div>

    </div>
</div>

<!-- case module creation row actions menu -->
<mat-menu #caseModuleCreationMenuActions="matMenu">
    <ng-template matMenuContent let-provisionFee="provisionFee">
        <button mat-menu-item [disabled]="true">Exportar como .pdf</button>
        <button mat-menu-item [disabled]="true">Exportar como .doc</button>
    </ng-template>
</mat-menu>

<ng-template #popUpMessage>
    <div class="flex-column center-none">
        <div class="flex-column align-center-center">
            <div class="flex-row align-center-center">
                <mat-icon svgIcon="WarningCircle" style="height: 55px; width: 55px;"></mat-icon>
            </div>
            <span class="subtitle-2 active-case-text-margin text-center">
                {{ this.message }}
            </span>
        </div>

        <div *ngIf="this.arrayTable?.length > 0" class="mt-2 flex-column center flex-100">
            <section class="table-container" tabindex="0">
                <table mat-table [dataSource]="this.arrayTable" class="pop-up-table">
                    <ng-container matColumnDef="supplyName">
                        <td mat-cell *matCellDef="let item">
                            {{ item.supplyName }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="quantity">
                        <td mat-cell *matCellDef="let item">
                            {{ item.quantity }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <ng-container matColumnDef="provider">
                        <td mat-cell *matCellDef="let item">
                            {{ item.provider }}
                        </td>
                        <td mat-footer-cell *matFooterCellDef></td>
                    </ng-container>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsPopUp;"></tr>
                </table>
            </section>
        </div>

        <div class="flex-column center-none m-2 border-data flex-100">
            <div class="flex-row align-space-evenly-center">
                <button mat-stroked-button (click)="onClickCancel()" [color]="'primary'">
                    {{ txtCancelBtn }}
                </button>
                <button mat-flat-button (click)="onClickPopupConfirm()" *ngIf="this.showConfirmBtn" [color]="'primary'">
                    {{ txtConfirmBtn }}
                </button>
            </div>
        </div>
    </div>
</ng-template>

<!-- CREAR PEDIDO (replica SupplyList) -->
<ng-template #addOrderTemplate>
    <div class="flex-column">
        <form [formGroup]="this.formAddOrder" *ngIf="this.formAddOrder" (submit)="onClickCreateOrder()"
            class="flex-column flex-100">
            <div class="flex-row align-space-between-center full-width">
                <div class="flex-column flex-45">
                    <span class="subtitle-3 text-primary-darker">Proveedor</span>
                    <app-select-searching-dynamic-input [name]="this.ORDER_PROVIDER"
                        [defaultValue]="this.actualProviderOrderSelected[0]" [elements]="this.providerOrderOnSelect[0]"
                        [nameSearching]="this.ORDER_PROVIDER_SEARCHING" [form]="this.formAddOrder"
                        [placeholder]="'Seleccionar'" [calculateId]="this.calculateIdProvider"
                        [calculateName]="this.calculateNameProvider" [placeholderNoValue]="'Sin resultados'"
                        [placeholderSearching]="'Buscar proveedor...'" [httpGet]="this.getProvidersByName"
                        [disabled]="true">
                    </app-select-searching-dynamic-input>
                </div>

                <div class="flex-column flex-45">
                    <span class="subtitle-3 text-primary-darker">Fecha de entrega</span>
                    <app-date-picker [name]="this.ORDER_DATE" [form]="this.formAddOrder" class=""></app-date-picker>
                </div>
            </div>

            <table mat-table [dataSource]="orderItemsDataSource">
                <ng-container matColumnDef="supplyRequested">
                    <th mat-header-cell *matHeaderCellDef style="padding-left: 12px; border-right: 1px solid #FFF">
                        Insumo
                    </th>
                    <td mat-cell *matCellDef="let order; let i = index;">
                        <span class="mbs-3">
                            {{ this.itemsFormArray['controls'][i].get(this.ITEM_PRACTICE).value?.name }}
                        </span>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="quantityRequested">
                    <th mat-header-cell *matHeaderCellDef>Cantidad</th>
                    <td mat-cell *matCellDef="let order; let i = index;" style="padding-inline: 5%;">
                        <div class="padding-top-15-important">
                            <app-number-input [name]="this.ITEM_QUANTITY" [form]="getItemsFormArrayFormGroup(i)"
                                [money]="false"
                                [suffix]="this.itemsFormArray['controls'][i].get(this.ITEM_UNIT).value + '/s'"
                                [suffixClass]="'text-secondary'" [readonly]="true">
                            </app-number-input>
                        </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <ng-container matColumnDef="priceRequested">
                    <th mat-header-cell *matHeaderCellDef>Costo</th>
                    <td mat-cell *matCellDef="let order; let i = index;">
                        <div class="padding-top-15-important">
                            <app-number-input [name]="this.ITEM_PRICE" [form]="getItemsFormArrayFormGroup(i)"
                                [money]="true" [readonly]="true" class="flex-70">
                            </app-number-input>
                        </div>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsSuppliesForOrder"></tr>
                <tr mat-row class="bg-on-hover parentShowOnHover" style="align-items: first baseline;"
                    *matRowDef="let row; columns: displayedColumnsSuppliesForOrder;"></tr>
            </table>

            <mat-divider class="divider-form mts-2"></mat-divider>

            <app-text-area-input class="flex-100" [name]="this.ORDER_OBSERVATIONS" [form]="this.formAddOrder"
                [placeholder]="'Observaciones del pedido'" [maxLength]="120">
            </app-text-area-input>

            <div class="flex-row align-space-around-center flex-100 mts-3">
                <button mat-stroked-button [color]="'primary'" type="button" (click)="closeOrderDialog()"
                    [disabled]="(isLoadingCreatingOrder$ | async)">
                    CANCELAR
                </button>
                <button mat-flat-button [color]="'primary'" type="submit"
                    [disabled]="(isLoadingCreatingOrder$ | async) || !this.formAddOrder.valid">
                    <span *ngIf="!(isLoadingCreatingOrder$ | async) else loadingIcon">CREAR PEDIDO</span>
                </button>
            </div>
        </form>
    </div>
</ng-template>

<!-- ADD AGREEMENT (replica provisions-detail: Crear acuerdo prestacional) -->
<ng-template #agreementTemplate>
    <form *ngIf="this.formAgreement" [formGroup]="this.formAgreement" (submit)="onClickConfirmFormAgreement()">
        <div class="flex-column gap-2em">
            <!-- Select providers -->
            <div class="flex-row flex-100 gap-5em">
                <div class="flex-column flex-45">
                    <span class="subtitle-3 text-primary-darker">Prestador *</span>

                    @if( actionAgreement === 'ACTUALIZAR' || actionAgreement === 'CORREGIR') {
                    <div class="readonly-container">
                        <mat-form-field appearance="outline" class="flex-100">
                            <input matInput [value]="this.formAgreement.get(this.PROVIDER_NAME)?.value"
                                [readonly]="true" class="flex-85 text-ellipsis" />
                            @if(!agreementToWork?.provider?.active){
                            <span matSuffix class="custom-chip flex-15">INACTIVO</span>
                            }
                        </mat-form-field>
                    </div>
                    } @else {
                    <app-select-searching-input [hidden]="!this.isAddModeAgreement" [name]="this.PROVIDER"
                        [elements]="this.providers" [defaultValue]="null" [nameSearching]="this.PROVIDER_SEARCHING"
                        [form]="this.formAgreement" [placeholder]="'Seleccione el prestador'"
                        [calculateId]="this.calculateIdProvider" [calculateName]="this.calculateNameProvider"
                        [placeholderNoValue]="'Sin resultados'" [placeholderSearching]="'Buscar prestador...'"
                        [disabled]="!this.isAddModeAgreement">
                    </app-select-searching-input>

                    <app-text-input [form]="this.formAgreement" [hidden]="this.isAddModeAgreement"
                        [name]="this.PROVIDER_NAME">
                    </app-text-input>
                    }
                </div>
            </div>

            <!-- Agreement fromDate -> toDate -->
            <div class="flex-row flex-100 flex-row-wrap gap-5em">
                <div class="flex-column flex-40">
                    <span class="subtitle-3 text-primary-darker max-content">Vigencia desde *</span>
                    <app-date-picker [name]="this.AGREEMENT_FROM_DATE" [form]="formAgreement"
                        (onDateChange)="onClickDateFrom($event)" class="max-content"></app-date-picker>
                </div>
                <div class="flex-column flex-40"
                    *ngIf="this.isAddModeAgreement || (!this.isAddModeAgreement && !this.isUpdateModeAgreement)">
                    <span class="subtitle-3 text-primary-darker max-content">Vigencia hasta</span>
                    <app-date-picker [name]="this.AGREEMENT_TO_DATE" [form]="formAgreement"
                        (onDateChange)="onClickDateTo($event)" class="max-content"></app-date-picker>
                </div>
            </div>

            <!-- Fee -->
            <ng-container *ngIf="!!this.isAddModeAgreement; else updateAgreement">
                <div class="flex-column flex-40">
                    <span class="subtitle-3 text-primary-darker">Costo *</span>
                    <app-number-input [name]="this.AGREEMENT_PROVISION_FEE" [minValue]="0" [form]="this.formAgreement"
                        [money]="true">
                    </app-number-input>
                </div>
            </ng-container>

            <ng-template #updateAgreement>
                <mat-radio-group class="flex-row gap-5em" formControlName="radioButton"
                    (change)="clickRadiobuttonAgreementCost($event)" name="radioButton">
                    <div class="flex-column flex-40">
                        <mat-radio-button class="subtitle-3 text-primary-darker"
                            [value]="'cost'">Costo</mat-radio-button>
                        <app-number-input [name]="this.AGREEMENT_PROVISION_FEE" [minValue]="0"
                            [form]="this.formAgreement" [money]="true" (change)="this.updateMargin()">
                        </app-number-input>
                    </div>

                    <div class="flex-column flex-40" *ngIf="!this.isAddModeAgreement && this.isUpdateModeAgreement">
                        <mat-radio-button class="subtitle-3 text-primary-darker" [value]="'margin'">Margen aplicado
                            sobre el valor</mat-radio-button>
                        <app-number-input [name]="this.AGREEMENT_MARGIN" [form]="this.formAgreement"
                            (change)="this.updateCost()" [suffix]="'%'">
                        </app-number-input>
                    </div>
                </mat-radio-group>
            </ng-template>

            <!-- Bottom actions -->
            <div class="flex-row align-end-center gap-1em">
                <button mat-stroked-button type="button" (click)="onClickCloseDialogAgreementTemplate()"
                    [disabled]="isLoadingUpdatingAgreement">
                    Cancelar
                </button>
                <button mat-flat-button color="primary" type="submit"
                    [disabled]="isLoadingUpdatingAgreement || isLoadingCreatingAgreement || !this.formAgreement.valid">
                    {{ this.actionAgreement || 'CREAR' }}
                </button>
            </div>
        </div>
    </form>
</ng-template>

<!-- case module row actions menu -->
<mat-menu #caseModuleMenuActions="matMenu">
    <ng-template matMenuContent let-cm="cm">
        <ng-container *ngIf="cm as m">
            <button mat-menu-item (click)="this.openUpdateAuthorizationDialog(cm)" id="addAuthorizationButton"
                *ngIf="!cm?.authorization"> Autorizar</button>
            <!-- <button mat-menu-item (click)="openRePostModuleDialog(cm)">Renovar</button> -->
            <button mat-menu-item (click)="openSuspendCaseModule(cm)">Finalizar</button>
            <button mat-menu-item (click)="openEditModuleDialog(m)">Corregir</button>
            <button mat-menu-item (click)="deleteCaseModule(cm.id)" [disabled]="hasPracticesOrSupplies(cm)">Eliminar</button>
        </ng-container>
    </ng-template>
</mat-menu>

<!-- case module provisions row actions menu -->
<mat-menu #caseModuleProvisionsMenuActions="matMenu">
    <ng-template matMenuContent let-provisionFee="provisionFee" let-provision="provision" let-cm="cm">
        <button mat-menu-item (click)="this.openSuspendPracticeProvisionFee(provision)" id="suspendProvisionFee"
            [disabled]="true">Finalizar</button>
        <button mat-menu-item (click)="this.amendPracticeProvisionFee(provision)" id="amendProvisionFee">Corregir</button>
        <button mat-menu-item (click)="deletePracticeModule(provision)" id="deletedProvisionFee" >Eliminar</button>
    </ng-template>
</mat-menu>

<!-- case module Order row actions menu -->
<!-- <mat-menu #caseModuleOrderMenuActions="matMenu">
    <ng-template matMenuContent let-provisionFee="provisionFee" let-provision="provision" let-cm="cm">
        <button mat-menu-item (click)="this.openSuspendPracticeProvisionFee(provision)" id="suspendProvisionFee">Entregar</button>
        <button mat-menu-item (click)="this.amendPracticeProvisionFee(provision)" id="amendProvisionFee">Generar remito</button>
        <button mat-menu-item (click)="null" id="deletedProvisionFee">Cancelar</button>
    </ng-template>
</mat-menu> -->

<!-- SUSPEND PRACTICE (replica provisions-detail: Finalizar práctica) -->
<ng-template #suspendPracticeTemplate>
    <form *ngIf="this.formSuspend" [formGroup]="this.formSuspend" (submit)="onClickSuspendPracticeProvisionFee()">
        <div class="flex-column">
            <div class="flex-row-wrap align-space-around-center">
                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">Práctica</span>
                    <app-text-input [name]="this.PRACTICE_NAME" [form]="this.formSuspend" [placeholder]="'Práctica'">
                    </app-text-input>
                </div>
                <div class="flex-row align-center-center gap-0-5 flex-40">
                    <div class="flex-column flex-50">
                        <span class="subtitle-3 text-primary-darker">Desde</span>
                        <app-date-picker [name]="this.VALIDITY_FROM_DATE" [form]="formSuspend"></app-date-picker>
                    </div>
                    <div class="flex-column flex-50">
                        <span class="subtitle-3 text-primary-darker">Hasta</span>
                        <app-date-picker [name]="this.VALIDITY_TO_DATE" [form]="formSuspend"></app-date-picker>
                    </div>
                </div>
            </div>

            <div class="flex-100 mts-3 gap-15px flex-row align-space-evenly-start flex-column-xs">
                <button mat-stroked-button [color]="'primary'" type="button" (click)="onClickCloseDialog()">
                    CANCELAR
                </button>
                <button mat-flat-button [color]="'primary'" type="submit" [disabled]="!this.formSuspend.valid">
                    <span>GUARDAR</span>
                </button>
            </div>
        </div>
    </form>
</ng-template>

<!-- AMEND PRACTICE (replica provisions-detail: Corregir esquema prestacional) -->
<ng-template #amendPracticeTemplate>
    <form *ngIf="this.formAmendPractice" class="flex-column flex-100" [formGroup]="this.formAmendPractice"
        (submit)="onClickConfirmAmendPracticeProvisionFee()" style="width: 100vh">
        <div class="flex-column">
            <div class="flex-row space-between-start mbs-3">
                <div class="flex-column align-start-start gap-gappx flex-50">
                    <div class="flex-row align-start-center gap-0-5em">
                        <span class="text-primary">Práctica: </span>
                        <span class="subtitle-2 text-primary-darker">{{ this.provisionToWork?.practice?.name || '-'
                            }}</span>
                    </div>
                </div>
            </div>

            <!-- Frequency -->
            <div class="flex-row space-between-center flex-100" style="gap: 2.5em;" [formGroup]="this.formFrequency">
                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">Frecuencia de visita *</span>
                    <div class="flex-row gap-0-5em" style="align-items: baseline;">
                        <div class="flex-30">
                            <app-number-input [name]="this.AMOUNT" [form]="this.formFrequency" [minValue]="0"
                                [money]="false">
                            </app-number-input>
                        </div>
                        <span class="subtitle-3 text-primary-darker flex-5"> por</span>
                        <div class="flex-50">
                            <app-select-input [name]="this.UNIT" [form]="this.formFrequency" [placeholder]="'Período'"
                                [elements]="this.provisionsFrequencyUnit" [calculateId]="this.calculateIdUnit"
                                [calculateName]="this.calculateNameUnit">
                            </app-select-input>
                        </div>
                    </div>
                </div>
                @if(isGuard()){
                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">Horas diarias *</span>
                    <app-number-input class="flex-50" [name]="this.HOURS" [form]="this.formFrequency" [minValue]="1"
                        [money]="false">
                    </app-number-input>
                </div>
                }
            </div>

            <!-- Validity -->
            <div class="flex-column">
                <div class="flex-row align-space-between-center flex-100">
                    <div class="flex-column flex-45">
                        <span class="subtitle-3 text-primary-darker">Vigencia desde *</span>
                        <app-date-picker [name]="this.VALIDITY_FROM_DATE" [form]="formAmendPractice" ></app-date-picker>
                    </div>
                    <div class="flex-column flex-45">
                        <span class="subtitle-3 text-primary-darker">Vigencia hasta</span>
                        <app-date-picker [name]="this.VALIDITY_TO_DATE" [form]="formAmendPractice"></app-date-picker>
                    </div>
                </div>
            </div>

            <!-- Bottom -->
            <div class="flex-column">
                <div class="flex-row mts-3 flex-100 align-space-evenly-center">
                    <button mat-stroked-button [color]="'primary'" type="button"
                        (click)="onClickCloseDialog()">CANCELAR</button>
                    <button mat-flat-button [color]="'primary'" type="submit"
                        [disabled]="(this.formAmendPractice?.invalid ?? true) || (this.formAmendPractice?.get(this.IS_ADDING_AUTHORIZATION)?.value === true && (this.formAuthorization?.invalid ?? true)) || (this.formAmendPractice?.get(this.IS_ADDING_AUTHORIZATION)?.value === true && !this.photoEvolutionB64) || this.loadingAddFile">
                        GUARDAR
                    </button>
                </div>
            </div>
        </div>
    </form>
</ng-template>

<!-- case module agreements  row actions menu -->
<mat-menu #caseModuleAgreementsMenuActions="matMenu">
    <ng-template matMenuContent let-provision="provision" let-agreement="agreement">
        <button mat-menu-item (click)="openUpdateAgreementDialogForCaseModule(provision, agreement)"
            id="updateAgreement">
            Actualizar
        </button>
        <button mat-menu-item (click)="openFixAgreementDialogForCaseModule(provision, agreement)" id="fixAgreement">
            Corregir
        </button>
        <button mat-menu-item (click)="onClickDeleteAgreementForCaseModule(provision, agreement)" id="deleteAgreement">
            Eliminar
        </button>
    </ng-template>
</mat-menu>

<!-- case module supplies row actions menu -->
<mat-menu #caseModuleSuppliesMenuActions="matMenu">
    <ng-template matMenuContent let-cm="cm">
        <button mat-menu-item (click)="openSuppliesEditPickerForCaseModule(cm)">Modificar</button>
        <button mat-menu-item (click)="onDeleteSuppliesFromMenu(cm)">Eliminar</button>
        <button mat-menu-item
            *ngIf="!isSomeSupplyWithoutUnitForModule(cm)"
            (click)="openLoadPriceForModule(cm)">
            Cargar cotización
        </button>
        <!-- Crear presupuesto PDF/DOC -->
        <button mat-menu-item
            *ngIf="!isSomeSupplyWithoutUnitForModule(cm)"
            [mat-menu-trigger-for]="suppliesExportBudget"
            (mouseenter)="showSuppliesBudgetMenu?.openMenu()"
            (mouseleave)="showSuppliesBudgetMenu?.closeMenu()">
            Crear presupuesto
        </button>
        <mat-menu #suppliesExportBudget="matMenu" [overlapTrigger]="false">
            <button mat-menu-item (click)="generateBudgetPDFForModule(cm, true)">Exportar como .pdf</button>
            <button mat-menu-item (click)="generateBudgetPDFForModule(cm, false)">Exportar como .doc</button>
        </mat-menu>
        <!-- Crear cotización PDF/DOC -->
        <button mat-menu-item
            *ngIf="!isSomeSupplyWithoutUnitForModule(cm)"
            [mat-menu-trigger-for]="suppliesExportQuote"
            (mouseenter)="showSuppliesQuoteMenu?.openMenu()"
            (mouseleave)="showSuppliesQuoteMenu?.closeMenu()">
            Crear cotización
        </button>
        <mat-menu #suppliesExportQuote="matMenu" [overlapTrigger]="false">
            <button mat-menu-item (click)="generateQuotePDFForModule(cm, true)">Exportar como .pdf</button>
            <button mat-menu-item (click)="generateQuotePDFForModule(cm, false)">Exportar como .doc</button>
        </mat-menu>
    </ng-template>
</mat-menu>

<!-- case module orders row actions menu -->
<mat-menu #caseModuleOrdersMenuActions="matMenu">
    <ng-template matMenuContent let-order="order">
        <button mat-menu-item (click)="this.openModifyOrderDialog(order, false)"
            *ngIf="order.state.id == this.ORDERS_STATES.ENTREGADO || order.state.id == this.ORDERS_STATES.CANCELADO">
            Ver detalle </button>
        <button mat-menu-item
            *ngIf="order.state.id == this.ORDERS_STATES.EN_CURSO || order.state.id == this.ORDERS_STATES.CREADO || order.state.id == this.ORDERS_STATES.EN_CURSO"
            (click)="this.openModifyOrderDialog(order, true)">
            {{order.state.id == this.ORDERS_STATES.EN_CURSO ? 'Entregar' : 'Confirmar'}}
        </button>
        <button mat-menu-item (click)="onClickGenerateDeliveryNote(order)">
            Generar remito
        </button>
        <button mat-menu-item *ngIf="order.state.id == this.ORDERS_STATES.ENTREGADO"
            [disabled]="order.state.id == this.ORDERS_STATES.CANCELADO"
            (click)="this.openModifyOrderDialog(order, true)">
            Editar
        </button>
        <button mat-menu-item
            *ngIf="order.state.id == this.ORDERS_STATES.EN_CURSO || order.state.id == this.ORDERS_STATES.CREADO"
            (click)="onClickDeleteOrder(order)">
            Cancelar
        </button>
        <button mat-menu-item *ngIf="order.state.id == this.ORDERS_STATES.ENTREGADO" (click)="this.revertState(order)">
            Revertir estado
        </button>
        <button mat-menu-item *ngIf="order.state.id == this.ORDERS_STATES.ENTREGADO"
            (click)="this.showDeliveryNote(order)">
            Ver remito
        </button>
    </ng-template>
</mat-menu>


<!-- ADD / UPDATE CASE MODULE -->
<ng-template #moduleTemplate>
    <form [formGroup]="this.formModule" (ngSubmit)="onSubmitModuleForm()">
        <div class="flex-column">
            <div class="flex-row align-start-baseline" *ngIf="!isShowRetroactive && isAddMode">
                <span class="subtitle-3 text-primary-darker">Convenio: </span>
                <mat-radio-group class="flex-row subtitle-3 text-primary-darker mbs-3" formControlName="arrangement"
                    [name]="this.ARRANGEMENT" (change)="this.radioButtonArrangementSelected($event)">
                    <mat-radio-button *ngFor="let element of this.caseArrangements" [value]="element.id" class=""
                        style="width: max-content;">
                        {{ element.name }}
                    </mat-radio-button>
                    <mat-radio-button [value]="'S/C'" class="subtitle-4">Sin convenio</mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="flex-row mbs-4 gap-5em" *ngIf="isEditMode">
                <div class="flex-row gap-0-5em">
                    <span class="subtitle-3">Módulo : </span>
                    <span class="subtitle-4"> {{moduleSelected?.name}}</span>
                </div>
                <div class="flex-row gap-0-5em">
                    <span class="subtitle-3">Convenio : </span>
                    <span class="subtitle-4"> {{arrangementSelected?.name ?? 'Sin convenio'}}</span>
                </div>
            </div>

            <div class="flex-row gap-1em">
                <!-- Module select -->
                <div class="flex-column flex-25" *ngIf=" isAddMode">
                    <span class="subtitle-3 text-primary-darker">Seleccionar módulo *</span>
                    <app-select-searching-input class="" [name]="this.MODULE" [nameSearching]="this.MODULE_SEARCHING"
                        [form]="this.formModule" (selected)="this.onSelectModule($event)"
                        [elements]="this.modulesFilteredByFinancier" [calculateId]="this.calculateIdModule"
                        [calculateName]="this.calculateNameModule" [defaultValue] [placeholderSearching]="'Buscar...'">
                    </app-select-searching-input>
                </div>

                <div class="flex-column flex-30">
                    <span class="subtitle-3 text-primary-darker">Frecuencia *</span>
                    <div class="flex-row" style="align-items: baseline;">
                        <!-- AMOUNT input -->
                        <div class="flex-30">
                            <app-number-input [name]="this.AMOUNT" [form]="this.formFrequency" [minValue]="0"
                                [money]="false">
                            </app-number-input>
                        </div>
                        <span class="subtitle-3 text-primary-darker flex-10 text-center"> por</span>
                        <!-- UNIT input -->
                        <div class="flex-30">
                            <app-select-input [name]="this.UNIT" [form]="this.formFrequency"
                                [placeholder]="'Seleccionar'" [elements]="this.provisionsFrequencyUnit"
                                [calculateId]="this.calculateIdUnit" [calculateName]="this.calculateNameUnit">
                            </app-select-input>
                        </div>
                    </div>
                </div>

                <!-- Validity / Vigencia -->
                <!-- From -->
                <div class="flex-column flex-20">
                    <span class="subtitle-3 text-primary-darker">Vigencia desde *</span>
                    <app-date-picker [name]="this.VALIDITY_FROM_DATE" [form]="formModule"></app-date-picker>
                </div>
                <!-- To -->
                <div class="flex-column flex-20">
                    <ng-container>
                        <span class="subtitle-3 text-primary-darker">Vigencia hasta *</span>
                    </ng-container>
                    <ng-template #vigencyNotRequired>
                        <span class="subtitle-3 text-primary-darker">Vigencia hasta</span>
                    </ng-template>
                    <app-date-picker [name]="this.VALIDITY_TO_DATE" [form]="formModule"></app-date-picker>
                </div>

            </div>

            <!-- Contenido del módulo (UI nueva) -->
            @if(!isEditMode){
            <div class="module-content-card" [class.module-content-card--disabled]="!moduleSelected">
                <div class="module-content-card__title">Contenido del módulo</div>
                <fieldset class="module-content-card__body" [disabled]="!moduleSelected">
                    <!-- Prácticas -->
                    <div class="module-section">
                        <div class="module-section__header cursor-pointer" (click)="togglePracticesPanel()">
                            <span>Prácticas</span>
                            <mat-icon>
                                {{ practicesPanelExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                            </mat-icon>
                        </div>

                        @if (practicesPanelExpanded) {
                        <div class="module-section__body">
                            @if (modulePracticesSelected?.length) {
                            <div class="module-practices-table-wrap">
                                <table
                                    class="module-practices-table module-practices-table--responsive module-practices-table--practice-name-wide"
                                    aria-label="Prácticas seleccionadas">
                                    <thead>
                                        <tr>
                                            <th scope="col">Código</th>
                                            <th scope="col">Práctica</th>
                                            <th scope="col">Frecuencia</th>
                                            <th scope="col">Cantidad de atenciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let p of modulePracticesSelected">
                                            <td data-label="Código">{{ p.code || p.practiceId }}</td>
                                            <td data-label="Práctica" class="module-practices-table__practice">
                                                <span class="text-ellipsis">{{ p.name }}</span>
                                            </td>
                                            <td data-label="Frecuencia">
                                                @if (p.frequencyAmount && p.frequencyUnit) {
                                                {{ p.frequencyAmount }} por {{ p.frequencyUnit }}
                                                @if (p.restrictionId === 2 && p.allowedHours) {
                                                {{ p.allowedHours }} hs por día
                                                }
                                                } @else {
                                                -
                                                }
                                            </td>
                                            <td data-label="Cantidad de atenciones">
                                                min. {{ p.minAttentions ?? '-' }} máx. {{ p.maxAttentions ?? '-' }}
                                                atenciones
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="module-items-actions mts-5">
                                    <button mat-button [color]="'primary'" type="button" class="module-items-edit"
                                        (click)="openPracticesPickerDialog()" [disabled]="!moduleSelected">
                                        Editar prácticas
                                    </button>
                                </div>
                            </div>
                            } @else {
                            <div class="module-items-box">
                                <button mat-button [color]="'primary'" type="button"
                                    (click)="openPracticesPickerDialog()" class="module-section__action"
                                    [disabled]="!moduleSelected">
                                    <mat-icon>add_circle_outline</mat-icon>
                                    <span>Cargar prácticas</span>
                                </button>
                            </div>
                            }
                        </div>
                        }
                    </div>

                    <!-- Insumos -->
                    <div class="module-section">
                        <div class="module-section__header cursor-pointer" (click)="toggleSuppliesPanel()">
                            <span>Insumos</span>
                            <mat-icon>
                                {{ suppliesPanelExpanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                            </mat-icon>
                        </div>

                        @if (suppliesPanelExpanded) {
                        <div class="module-section__body">
                            @if (moduleSuppliesSelected?.length) {
                            <div class="module-practices-table-wrap">
                                <table class="module-practices-table module-practices-table--responsive"
                                    aria-label="Insumos seleccionados">
                                    <thead>
                                        <tr>
                                            <th scope="col">Código</th>
                                            <th scope="col">Insumo</th>
                                            <th scope="col">Proveedor</th>
                                            <th scope="col">Cantidad</th>
                                            <th scope="col">Unidad</th>
                                            <th scope="col">Costo unitario</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let s of moduleSuppliesSelected">
                                            <td data-label="Código">{{ s.code || s.practiceId }}</td>
                                            <td data-label="Insumo">{{ s.name }}</td>
                                            <td data-label="Proveedor">{{ s.providerName || '-' }}</td>
                                            <td data-label="Cantidad">{{ s.quantity ?? '-' }}</td>
                                            <td data-label="Unidad">{{ s.unit || '-' }}</td>
                                            <td data-label="Costo unitario">
                                                @if (s.unitCost != null) {
                                                $ {{ s.unitCost | number:'1.0-2' }}
                                                } @else {
                                                -
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div class="module-items-actions mts-5">
                                    <button mat-button [color]="'primary'" type="button" class="module-items-edit"
                                        (click)="openSuppliesPickerDialog()" [disabled]="!moduleSelected">
                                        Editar insumos
                                    </button>
                                </div>
                            </div>
                            } @else {
                            <div class="module-items-box">
                                <button mat-button [color]="'primary'" type="button"
                                    (click)="openSuppliesPickerDialog()" class="module-section__action"
                                    [disabled]="!moduleSelected">
                                    <mat-icon>add_circle_outline</mat-icon>
                                    <span>Cargar insumos</span>
                                </button>
                            </div>
                            }
                        </div>
                        }
                    </div>
                </fieldset>
            </div>
            }
            <div class="flex-row mts-5 pls-2">
                <!-- Fee input (compact row) -->
                <div class="flex-row align-center-baseline gap-1em" *ngIf="!this.showTxtWithOutArrangement">
                    <span class="subtitle-3 text-primary-darker module-fee-row__label">Valor venta *</span>
                    <app-number-input class="module-fee-row__input" [name]="this.FEE" [form]="this.formModule"
                        [money]="true" [minValue]="0">
                    </app-number-input>
                </div>

                <!-- Grid fees list / Price list -->
                <div *ngIf="this.showTxtWithOutArrangement" class="border-filters grid-fees-list px-2 mbs-4" [ngClass]="{'grid-fees-list-columns-2': !!this.arrangementItemsByPractice,
                                'grid-fees-list-columns-1': !this.arrangementItemsByPractice}">
                    <ng-container *ngIf="!!this.arrangementItemsByPractice; else emptyMessage">
                        <div class="subtitle-3 text-primary-darker">Valor venta</div>
                        <div class="subtitle-3 text-primary-darker">Período</div>
                        <ng-container *ngFor="let item of this.arrangementItemsByPractice">
                            <div class="body-3">
                                {{item.fee != -1
                                ? (item.fee.toFixed(2) | currency: 'ARS':'symbol':'1.2')
                                : 'No definido'
                                }}
                            </div>
                            <div class="body-3">
                                {{ item.fromDate | date: 'dd/MM/yyyy' }} -
                                {{ !!item.toDate ? (item.toDate | date: 'dd/MM/yyyy') : 'en adelante' }}
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-template #emptyMessage class="grid-columns-1">
                        <span *ngIf="existPriceList" class="body-3 text-primary" style="text-align: center;">Debe
                            seleccionar una práctica para ver la lista de valores de venta e ingresar
                            la vigencia</span>
                        <span *ngIf="!existPriceList" class="body-3 text-primary" style="text-align: center;">No hay
                            valores de venta definidos para el convenio en el rango de fechas
                            especificado</span>
                    </ng-template>
                </div>
            </div>

            <!-- Authorization -->
            <div *ngIf="isShowAuth" class="separator separator-center mts-1 flex-100">
                <b class="mx-2 text-primary-darker">
                    Autorizar
                </b>
            </div>

            <app-checkbox-input *ngIf="isShowAuth" class="flex-1-1-auto mbs-2" [labelPosition]="'before'"
                [form]="this.formModule" [label]="checkboxAuthorizationText" [name]="this.IS_ADDING_AUTHORIZATION">
            </app-checkbox-input>

            <div *ngIf="this.formModule.get(this.IS_ADDING_AUTHORIZATION).value" [formGroupName]="this.AUTHORIZATION"
                class="flex-column flex-100">
                <div class="flex-row space-between">
                    <div class="flex-column flex-45">
                        <span class="subtitle-3 text-primary-darker">Número de autorización *</span>
                        <app-text-input [name]="this.AUTHORIZATION_NUMBER" [form]="this.formAuthorization">
                        </app-text-input>
                    </div>
                </div>
                <div class="flex-row align-space-between-center">
                    <div class="flex-column flex-45">
                        <span class="subtitle-3 text-primary-darker">Observaciones de la autorización</span>
                        <app-text-area-input class="flex-100" [name]="this.AUTHORIZATION_OBSERVATIONS"
                            [form]="this.formAuthorization" [maxLength]="120">
                        </app-text-area-input>
                    </div>
                    <div class="flex-column flex-45">
                        <div style="height: 25px;">
                            <span class="subtitle-3" style="color:red" *ngIf="this.photoEvolutionB64 == null">
                                Archivo requerido
                            </span>
                        </div>
                        <file-pond #myPond [options]="pondOptions" (oninit)="pondHandleInit()"
                            (onaddfile)="pondHandleAddFile($event)" (onremovefile)="pondHandleRemoveFile($event)"
                            (onaddfilestart)="pondHandleProcessFile($event)" id="Case_fileSelector"
                            class="filepond--panel-root" fxFlex="48">
                        </file-pond>
                    </div>
                </div>
            </div>

            <mat-error class="mls-3" *ngIf="
                this.formAuthorization.errors &&
                (this.formAuthorization.dirty || this.formAuthorization.touched)" class="align-start-center">
                <mat-icon class="text-warn mrs-2">error_outline</mat-icon>
                <!-- {{ objectValues(this.formAuthorization.errors)[0] }} -->
            </mat-error>

            <!-- Bottom -->
            <div class="flex-column">
                <!-- <mat-error *ngIf="this.formProvision?.errors['fromToDate']" class="subtitle-3"
                    style="text-align: center">Rango de fechas de vigencia incorrecto</mat-error> -->
                <div class="flex-row mts-3 flex-100 align-space-evenly-center">
                    <button mat-stroked-button [color]="'primary'" type="button" (click)="onClickCloseDialog()"
                        [disabled]="isAddMode ? _isLoadingCreatingCaseModule : _isLoadingUpdatingCaseModule">
                        CANCELAR
                    </button>

                    <button mat-flat-button [color]="'primary'" type="submit"
                        [disabled]="(this.formModule?.invalid ?? true) || (this.formModule?.get(this.IS_ADDING_AUTHORIZATION)?.value === true && (this.formAuthorization?.invalid ?? true)) ||
                        (this.formModule?.get(this.IS_ADDING_AUTHORIZATION)?.value === true && !this.photoEvolutionB64) || this.loadingAddFile || (isAddMode ? _isLoadingCreatingCaseModule : _isLoadingUpdatingCaseModule)">
                        <span *ngIf="!(isAddMode ? _isLoadingCreatingCaseModule : _isLoadingUpdatingCaseModule)">
                            @if (isAddMode) {
                            AGREGAR
                            } @else if (isRePostMode) {
                            RENOVAR
                            } @else {
                            ACTUALIZAR
                            }
                        </span>
                        <mat-spinner *ngIf="isAddMode ? _isLoadingCreatingCaseModule : _isLoadingUpdatingCaseModule"
                            color="accent" diameter="20"></mat-spinner>
                    </button>
                </div>
            </div>
        </div>
    </form>
</ng-template>

<!-- ADD SUPPLIES FORM-->
<ng-template #suppliesPickerTemplate>
    <div class="flex-column" *ngIf="suppliesPickerForm" [formGroup]="suppliesPickerForm">
        <app-text-searching-input class="flex-70" [leftIconClass]="'text-primary'" [leftIcon]="'search'"
            [placeholder]="'Búsqueda rápida'" [label]="'Ingrese el nombre o código del insumo'"
            (onSearch)="onSuppliesPickerSearch($event)">
        </app-text-searching-input>

        <div class="" style="overflow: auto;">
            <table mat-table class="supplies-picker-table" [dataSource]="filteredSuppliesPickerRowVM"
                style="width: 100%">

                <!-- Master / row check -->
                <ng-container matColumnDef="selected">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (click)="$event.stopPropagation()" [checked]="isAllPickerSuppliesSelected()"
                            [indeterminate]="isSomePickerSuppliesSelected()"
                            (change)="toggleAllPickerSupplies($event.checked)">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()" [formControl]="row.fg.get('selected')">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="supply">
                    <th mat-header-cell *matHeaderCellDef>Insumo</th>
                    <td mat-cell *matCellDef="let row">
                        <div class="flex-column">
                            <div class="flex-row">
                                <span class="subtitle-4 flex-30 text-ellipsis text-start"
                                    [matTooltip]="row.fg.get('code')?.value || 'S/C'">
                                    {{ row.fg.get('code')?.value || 'S/C' }}
                                </span>
                                <span class="subtitle-4 text-ellipsis flex-70 text-start"
                                    [matTooltip]="row.fg.get('name')?.value">
                                    {{ row.fg.get('name')?.value }}
                                </span>
                            </div>

                            <span
                                *ngIf="!suppliesPickerEditMode && row.fg.get('selected')?.value && isSupplyAlreadyAddedInCaseModuleForPicker(row.fg.get('practiceId')?.value)"
                                class="subtitle-5 text-warn">
                                Ya está agregado al módulo
                            </span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="provider">
                    <th mat-header-cell *matHeaderCellDef>Proveedor</th>
                    <td mat-cell *matCellDef="let row">
                        <app-select-searching-dynamic-input class="" [name]="'providerId'"
                            [nameSearching]="'providerSearching'" [form]="row.fg" [httpGet]="this.getProvidersByName"
                            [calculateId]="this.calculateIdProvider" [calculateName]="this.calculateNameProvider"
                            [defaultValue]="this.supplyPickerDefaultProviders[row.index]"
                            [elements]="this.supplyPickerProvidersOnSelect[row.index]" [placeholder]="'Seleccionar'"
                            [placeholderNoValue]="'Sin resultados'" [placeholderSearching]="'Buscar...'"
                            [noOptionText]="'Sin proveedor'"
                            (selectedWithEntity)="onSupplyPickerProviderSelected(row.fg, $event)">
                        </app-select-searching-dynamic-input>

                    </td>
                </ng-container>

                <ng-container matColumnDef="quantity">
                    <th mat-header-cell *matHeaderCellDef>Cant.</th>
                    <td mat-cell *matCellDef="let row">

                        <app-number-input [form]="row.fg" [name]="'quantity'" [minValue]="0" [money]="false">
                        </app-number-input>

                    </td>
                </ng-container>

                <ng-container matColumnDef="unit">
                    <th mat-header-cell *matHeaderCellDef>Unidad</th>
                    <td mat-cell *matCellDef="let row">

                        <app-select-input [name]="'unit'" [form]="row.fg" [placeholder]="'Unidad'"
                            [elements]="provisionsUnitOptions" [calculateId]="calculateIdUnit"
                            [calculateName]="calculateNameUnit">
                        </app-select-input>

                    </td>
                </ng-container>

                <ng-container matColumnDef="unitCost">
                    <th mat-header-cell *matHeaderCellDef>Costo Unitario</th>
                    <td mat-cell *matCellDef="let row">

                        <app-number-input [form]="row.fg" [name]="'unitCost'" [minValue]="0" [money]="true">
                        </app-number-input>

                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="supplyPickerDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: supplyPickerDisplayedColumns" [formGroup]="row.fg">
                </tr>
            </table>
        </div>

        <div class="flex-row align-space-evenly-start gap-1em mts-2">
            <button mat-stroked-button [color]="'primary'" type="button" (click)="closeSuppliesPickerDialog()"
                [disabled]="(isLoadingUpdatingCaseModule$ | async)">
                CANCELAR
            </button>
            <button mat-flat-button [color]="'primary'" type="button" (click)="applySuppliesPickerSelection()"
                [disabled]="(!suppliesPickerEditMode && getSelectedPickerSuppliesCount() === 0) || (isLoadingUpdatingCaseModule$ | async)">
                <span *ngIf="!(isLoadingUpdatingCaseModule$ | async); else loadingIcon">CARGAR</span>
            </button>
        </div>
    </div>
</ng-template>

<!-- ADD-PRACTICES FORM -->
<ng-template #practicesPickerTemplate>
    <div class="flex-column" *ngIf="practicesPickerForm" [formGroup]="practicesPickerForm">
        <div class="flex-row align-start-center gap-0-5em mbs-2">
            <mat-icon class="text-primary">info</mat-icon>
            <span class="subtitle-4 text-primary">Agrega una o varias prácticas del módulo al esquema
                prestacional.</span>
        </div>

        <app-text-searching-input [leftIconClass]="'text-primary'" [leftIcon]="'search'"
            [placeholder]="'Buscar práctica por nombre o código'" [label]="''"
            (onSearch)="onPracticesPickerSearch($event)">
        </app-text-searching-input>

        <div style="overflow: auto;">
            <table mat-table class="practices-picker-table" [dataSource]="filteredPracticePickerRowVM"
                style="width: 100%;">

                <!-- Master / row check -->
                <ng-container matColumnDef="selected">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (click)="$event.stopPropagation()" [checked]="isAllPickerPracticesSelected()"
                            [indeterminate]="isSomePickerPracticesSelected()"
                            [disabled]="getSelectablePickerPracticesCount() === 0"
                            (change)="toggleAllPickerPractices($event.checked)">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()" [formControl]="row.fg.get('selected')">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="practice">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex align-start-center mls-5">
                            <span class="text-start">Práctica</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div class="practice-picker-practice-row">
                            <span class="practice-picker-practice__code subtitle-4 text-start">
                                {{ row.fg.get('code')?.value || 'S/C' }}
                            </span>
                            <span class="practice-picker-practice__name subtitle-4 text-ellipsis text-start"
                                matTooltip="{{ row.fg.get('name')?.value }}">
                                {{ row.fg.get('name')?.value }}
                            </span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="frequency">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex align-start-center">
                            <span class="text-start">Frecuencia</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div class="practice-picker-frequency-row">
                            <app-number-input class="flex-15" [form]="row.fg" [name]="'frequencyAmount'" [minValue]="1"
                                [maxValue]="1000" [money]="false"
                                (focusout)="markPracticePickerControlTouched(row.fg, 'frequencyAmount')"
                                [placeholder]="'Frecuencia'">
                            </app-number-input>
                            <span class="subtitle-4 flex-10">por</span>
                            <app-select-input class="flex-20" [name]="'frequencyUnit'" [form]="row.fg"
                                [placeholder]="'Seleccionar'"
                                (focusout)="markPracticePickerControlTouched(row.fg, 'frequencyUnit')"
                                [elements]="this.provisionsFrequencyUnit" [calculateId]="calculateIdUnit"
                                [calculateName]="calculateNameUnit">
                            </app-select-input>
                            <app-number-input *ngIf="row.fg.get('restrictionId')?.value === 2" class="flex-15"
                                [form]="row.fg" [name]="'allowedHours'" [minValue]="1" [maxValue]="24" [money]="false"
                                (focusout)="markPracticePickerControlTouched(row.fg, 'allowedHours')"
                                [placeholder]="'Horas diarias'">
                            </app-number-input>
                            <span *ngIf="row.fg.get('restrictionId')?.value === 2" class="subtitle-4 flex-20">
                                {{row.fg.get('allowedHours')?.value === 1 ? 'hora diaria' : 'horas diarias'}}</span>
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="attentions">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="flex align-start-center">
                            <span class="text-start">Cantidad de atenciones</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <div class="practice-picker-attentions-row">
                            <span class="subtitle-4 flex-10">min.</span>
                            <app-number-input class="practice-picker-attentions__input" [form]="row.fg" class="flex-20"
                                [name]="'minAttentions'" [minValue]="0" [money]="false">
                            </app-number-input>
                            <span class="subtitle-4 flex-10">máx.</span>
                            <app-number-input class="practice-picker-attentions__input" [form]="row.fg" class="flex-20"
                                [name]="'maxAttentions'" [minValue]="0" [money]="false">
                            </app-number-input>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="practicePickerDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: practicePickerDisplayedColumns" [formGroup]="row.fg"
                    [class.practice-picker-row--has-error]="isPracticePickerRowWithVisibleErrors(row.fg)">
                </tr>
            </table>
        </div>

        <div class="flex-row align-space-evenly-start gap-1em mts-3">
            <button mat-stroked-button [color]="'primary'" type="button"
                (click)="closePracticesPickerDialog()">CANCELAR</button>
            <button mat-flat-button [color]="'primary'" type="button" (click)="applyPracticesPickerSelection()"
                [disabled]="getSelectedPickerPracticesCount() === 0">
                CARGAR
            </button>
        </div>
    </div>
</ng-template>

<!-- ORDERS TABLE -->
@if(!hideOrdersSection){
@if(ordersDataSource.data.length > 0){
<div class="flex pxs-1 orders-section mts-5">
    <table mat-table [dataSource]="ordersDataSource" multiTemplateDataRows class="orders-mat-table"
        [class.orders-collapsed]="isCollapsed" [trackBy]="trackByOrderId" style="width: 100%; border-radius: 10px;">

        <!-- ========== COLUMNAS CABECERA / FILA PRINCIPAL ========== -->

        <!-- Arrow para expandir/colapsar -->
        <ng-container matColumnDef="ordersExpand">
            <th mat-header-cell *matHeaderCellDef class="orders-header-cell"
                style="width: 40px; min-width: 40px; padding: 0;"></th>
            <td mat-cell *matCellDef="let order" style="width: 40px; min-width: 40px; padding: 0;">
                <div class="flex-row align-center-center">
                    <button mat-icon-button (click)="$event.stopPropagation(); toggleOrderRow(order)">
                        <mat-icon color="primary">
                            {{ order === expandedOrder ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
                        </mat-icon>
                    </button>
                </div>
            </td>
        </ng-container>

        <!-- Radio Button (header) / Checkbox (rows) - alineados -->
        <ng-container matColumnDef="ordersRadio">
            <th mat-header-cell *matHeaderCellDef class="orders-header-cell"
                style="width: 40px; min-width: 40px; padding: 0;">
                <!-- @if(singleSelectionMode) {
                <div class="flex-row align-center-center">
                    <mat-radio-button (click)="$event.stopPropagation()" (change)="selectOrdersRadio()"
                        [checked]="ordersRadioSelected">
                    </mat-radio-button>
                </div>
                } -->
            </th>
            <td mat-cell *matCellDef="let order" style="width: 40px; min-width: 40px; padding: 0;">
                <div class="flex-row align-center-center">
                    <mat-checkbox color="primary" [checked]="isOrderSelected(order)" (click)="$event.stopPropagation()"
                        (change)="toggleOrderSelection(order)">
                    </mat-checkbox>
                </div>
            </td>
        </ng-container>

        <!-- Pedidos (nombre) -->
        <ng-container matColumnDef="ordersName">
            <th mat-header-cell *matHeaderCellDef class="orders-header-cell">
                Pedidos
            </th>
            <td mat-cell *matCellDef="let order">
                <span class="subtitle-3 text-primary text-ellipsis">
                    Pedido {{ order.id }}
                </span>
            </td>
        </ng-container>

        <!-- Proveedor -->
        <ng-container matColumnDef="ordersProvider">
            <th mat-header-cell *matHeaderCellDef class="orders-header-cell">
                Proveedor
            </th>
            <td mat-cell *matCellDef="let order" class="subtitle-3 text-primary text-ellipsis">
                {{ getOrderProviderName(order) }}
            </td>
        </ng-container>

        <!-- Cantidad -->
        <ng-container matColumnDef="ordersQuantity">
            <th mat-header-cell *matHeaderCellDef class="orders-header-cell">
                Cantidad
            </th>
            <td mat-cell *matCellDef="let order" class="subtitle-3 text-primary text-ellipsis">
                {{ getOrderTotalQuantity(order) }} insumos
            </td>
        </ng-container>

        <!-- Fecha estimada -->
        <ng-container matColumnDef="ordersDate">
            <th mat-header-cell *matHeaderCellDef class="orders-header-cell">
                Fecha estimada
            </th>
            <td mat-cell *matCellDef="let order" class="subtitle-3 text-primary text-ellipsis">
                {{ order.orderDate | date:'dd/MM/yy, HH:mm' }}
            </td>
        </ng-container>

        <!-- Fecha de entrega -->
        <ng-container matColumnDef="orderDelivered">
            <th mat-header-cell *matHeaderCellDef class="orders-header-cell">
                Fecha de entrega
            </th>
            <td mat-cell *matCellDef="let order" class="subtitle-3 text-primary text-ellipsis">
                <ng-container *ngIf="order.deliveryDate; else notDelivered">
                    {{ order.deliveryDate | date:'dd/MM/yy, HH:mm' }}
                </ng-container>
                <ng-template #notDelivered>
                    No entregado aún
                </ng-template>
            </td>
        </ng-container>

        <!-- Estado -->
        <ng-container matColumnDef="orderState">
            <th mat-header-cell *matHeaderCellDef class="orders-header-cell">Estado</th>
            <td mat-cell *matCellDef="let order">
                <mat-chip-listbox>
                    <mat-chip
                        [matTooltip]="this.orderSharedActionsService.matTooltipText(order) + ' - ' + ( order.state.name | uppercase )"
                        [ngStyle]="{'color': this.orderSharedActionsService.setOrderColor(order.state.id).color, 'background-color': this.orderSharedActionsService.setOrderColor(order.state.id).background_color}"
                        selected>
                        <span matTooltipClass="multiline-tooltip" class="mat-small" style="cursor: pointer;">
                            {{ order.state.name | titlecase | uppercase | firstLetterWordsIntoString}}
                        </span>
                    </mat-chip>
                </mat-chip-listbox>
                <!-- <span class="order-state-chip" [ngClass]="{
              'state-creado': (order.state?.name || '').toUpperCase() === 'CREADO',
              'state-en-curso': (order.state?.name || '').toUpperCase() === 'EN CURSO',
              'state-entregado': (order.state?.name || '').toUpperCase() === 'ENTREGADO'
            }">
                    {{ order.state?.name | firstLetterWordsIntoString }}
                </span> -->
            </td>
        </ng-container>

        <!-- Acciones -->
        <ng-container matColumnDef="orderActions">
            <th mat-header-cell *matHeaderCellDef class="orders-header-cell actions-header"></th>
            <td mat-cell *matCellDef="let order" class="text-center">
                <button mat-icon-button (click)="$event.stopPropagation()"
                    [matMenuTriggerFor]="caseModuleOrdersMenuActions" [matMenuTriggerData]="{ order: order }">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </td>
        </ng-container>

        <!-- ========== FILA DETALLE (TABLA HIJA) ========== -->
        <ng-container matColumnDef="orderDetail">
            <td mat-cell *matCellDef="let order" class="orders-detail-cell" [attr.colspan]="activeOrdersColumns.length">
                <div class="order-detail-wrapper" [@detailExpand]="expandedOrder === order ? 'expanded' : 'collapsed'"
                    *ngIf="expandedOrder === order">
                    <table mat-table [dataSource]="getOrderItems(order)" class="order-items-table"
                        [trackBy]="trackByItemId">

                        <!-- Módulo -->
                        <ng-container matColumnDef="orderItemModule">
                            <th mat-header-cell *matHeaderCellDef class=" order-items-header-cell">
                                <span class="subtitle-3 text-primary">Módulo</span>
                            </th>
                            <td mat-cell *matCellDef="let item" class="order-item-td">
                                {{ getOrderModuleLabel(item) }}
                            </td>
                        </ng-container>

                        <!-- Código insumo -->
                        <ng-container matColumnDef="orderItemCode">
                            <th mat-header-cell *matHeaderCellDef class="order-items-header-cell">
                                <span class="subtitle-3 text-primary">Código insumo</span>
                            </th>
                            <td mat-cell *matCellDef="let item" class="order-item-td">
                                {{ item.practice?.code }}
                            </td>
                        </ng-container>

                        <!-- Insumos -->
                        <ng-container matColumnDef="orderItemName">
                            <th mat-header-cell *matHeaderCellDef class="order-items-header-cell">
                                <span class="subtitle-3 text-primary">Insumos</span>
                            </th>
                            <td mat-cell *matCellDef="let item" class="order-item-td">
                                {{ item.practice?.name }}
                            </td>
                        </ng-container>

                        <!-- Cantidad -->
                        <ng-container matColumnDef="orderItemQuantity">
                            <th mat-header-cell *matHeaderCellDef class="order-items-header-cell">
                                <span class="subtitle-3 text-primary">Cantidad</span>
                            </th>
                            <td mat-cell *matCellDef="let item" class="order-item-td">
                                {{ getOrderDeliveredQuantity(item) }} unidades
                            </td>
                        </ng-container>

                        <!-- Valor costo unitario -->
                        <ng-container matColumnDef="orderItemUnitCost">
                            <th mat-header-cell *matHeaderCellDef class="order-items-header-cell">
                                <span class="subtitle-3 text-primary">Valor costo unitario</span>
                            </th>
                            <td mat-cell *matCellDef="let item" class="order-item-td">
                                {{ (item?.provisionFee?.agreement?.providerFee) | currency:'ARS':'symbol':'1.0-2' }}
                            </td>
                        </ng-container>

                        <!-- Header row -->
                        <tr mat-header-row *matHeaderRowDef="activeOrderItemsColumns" class="order-items-header-row">
                        </tr>

                        <!-- Data rows -->
                        <tr mat-row *matRowDef="let item; columns: activeOrderItemsColumns" class="order-items-row">
                        </tr>

                    </table>
                </div>
            </td>
        </ng-container>

        <!-- ========== FOOTER ========== -->
        <ng-container matColumnDef="ordersFooter">
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="activeOrdersColumns.length">
                <div class="modules-footer pxs-5 pts-2">
                    <div class="modules-footer__item">
                        <span class="modules-footer__label">PEDIDOS :</span>
                        <span class="modules-footer__value"> {{ ordersDataSource.data.length || 0 }}</span>
                    </div>
                </div>
            </td>
        </ng-container>

        <!-- Header -->
        <tr mat-header-row *matHeaderRowDef="activeOrdersColumns" class="orders-header-row"></tr>

        <!-- Fila principal -->
        <tr mat-row *matRowDef="let order; columns: activeOrdersColumns;" class="orders-main-row"
            (click)="toggleOrderRow(order)" [class.orders-row-expanded]="expandedOrder === order"
            [class.orders-row-warning]="order.paintedType === ViewManagementEntities.SUPPLIES_NOT_DELIVERED"></tr>

        <!-- Fila detalle -->
        <tr mat-row *matRowDef="let order; columns: ['orderDetail'];" class="orders-detail-row"></tr>

        <!-- Footer -->
        <tr mat-footer-row *matFooterRowDef="isCollapsed ? [] : ordersFooterColumns" class="orders-footer-row"></tr>
    </table>
</div>
}@else {
<div class="flex align-center-center mts-3">
    <span class="subtitle-3 text-secondary">No hay pedidos asociados a módulos</span>
</div>
}
}

<!-- UPDATE AUTHORIZATION FORM -->
<ng-template #updateAuthorizationTemplate>
    <div class="flex-column">
        <form *ngIf="this.formAuthorization" class="flex-column flex-100" [formGroup]="this.formAuthorization"
            (submit)="onClickCreateAuthorization()">
            <div class="flex-row align-space-between-center gap-2em">
                <div class="flex-row">
                    <div class="flex-column">
                        <span class="subtitle-3 text-primary-darker bs-0">Número de autorización *</span>
                        <app-text-input [name]="this.AUTHORIZATION_NUMBER" [form]="this.formAuthorization"
                            [placeholder]="'Número de autorización'"></app-text-input>
                    </div>
                </div>
                <div class="flex-row align-end-center flex-gap-small">
                    <div class="flex-column"
                        [ngClass]="{'disabledElements' : !!this.provisionFeeSelectedToAutorize.fromDate}">
                        <span class="subtitle-3 text-primary-darker bs-0">
                            Desde *
                        </span>
                        <app-date-picker [name]="this.AUTHORIZATION_FROM_DATE" [form]="formAuthorization"
                            [disabled]="true" [readonly]="true">
                        </app-date-picker>
                    </div>
                    <div class="flex-column"
                        [ngClass]="{'disabledElements' : !!this.provisionFeeSelectedToAutorize.toDate}">
                        <span class="subtitle-3 text-primary-darker bs-0">
                            Hasta *
                        </span>
                        <app-date-picker [name]="this.AUTHORIZATION_TO_DATE" [form]="formAuthorization"
                            [disabled]="!!this.provisionFeeSelectedToAutorize.toDate"
                            [readonly]="!!this.provisionFeeSelectedToAutorize.toDate">
                        </app-date-picker>
                    </div>
                </div>
            </div>
            @if(provisionFeeSelectedToAutorize.toDate){
            <div class="flex-100 flex-row align-end-end" style="transform: translate(0, -70%);">
                <span class="text-secondary" style="font-size: smaller;;"><i> Para editar las fechas de vigencia,
                        ingresar a “corregir” desde el menú de la práctica</i> </span>
            </div>
            }
            <div class="flex-row gap-2em flex-100 align-center-center">
                <div class="flex-column flex-52">
                    <span class="subtitle-3 text-primary-darker bs-0">
                        Observaciones de la autorización
                    </span>
                    <app-text-area-input class="flex-100" [height]="36" [name]="this.AUTHORIZATION_OBSERVATIONS"
                        [form]="this.formAuthorization" [placeholder]="'Ingrese el texto aquí'" [maxLength]="120">
                    </app-text-area-input>
                </div>
                <div class="flex-column flex-1-1-auto ">
                    <span class="subtitle-3" style="color:red" *ngIf="this.photoEvolutionB64 == null">
                        Archivo requerido
                    </span>
                    <file-pond #myPond [options]="pondOptions" (oninit)="pondHandleInit()" required="true"
                        (onaddfile)="pondHandleAddFile($event)" (onremovefile)="pondHandleRemoveFile($event)"
                        (onaddfilestart)="pondHandleProcessFile($event)" id="Case_fileSelector">
                    </file-pond>
                </div>
            </div>
            <div class="flex-100 mts-3 gap-15px flex-row align-space-evenly-start flex-column-xs">
                <button mat-stroked-button [color]="'primary'" type="button" (click)="onClickCloseDialog()"
                    [disabled]="isLoadingUpdatingCaseModule$ | async">
                    CANCELAR
                </button>
                <button mat-flat-button [color]="'primary'" type="submit" [disabled]=" (isLoadingUpdatingCaseModule$ | async) ||
                        !this.formAuthorization.valid ||
                        this.photoEvolutionB64 == null">
                    <span *ngIf="!(isLoadingUpdatingCaseModule$ | async); else loadingIcon">GUARDAR</span>
                </button>
            </div>
        </form>
    </div>
</ng-template>

<ng-template #loadingIcon>
    <mat-icon>
        <mat-spinner color="accent" diameter="20"> </mat-spinner>
    </mat-icon>
</ng-template>

<!-- Suspend / Finalize CASE MODULE -->
<ng-template #suspendCaseModuleTemplate>
    <form (submit)="onClickFinalizeCaseModule()">
        <div class="flex-column gap-2em">
            <!-- Spans -->
            <div class="flex-row gap-2em">
                <div class="flex-row flex-50 gap-1em">
                    <span class="subtitle-3 text-primary-darker">Módulo</span>
                    <span class="subtitle-4 text-primary-darker">{{ caseModuleToWork.name }}</span>
                </div>

                <div class="flex-row flex-50 gap-1em">
                    <span class="subtitle-3 text-primary-darker">Convenio</span>
                    <span class="subtitle-4 text-primary-darker">
                        {{ caseModuleToWork.arrangementName ?? 'Sin convenio' }}
                    </span>
                </div>
            </div>

            <!-- Validity -->
            <div class="flex-row align-start-center gap-2em">
                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">Desde</span>
                    <app-date-picker [name]="this.VALIDITYMODULE_FROM_DATE" [form]="formSuspendCaseModule">
                    </app-date-picker>
                </div>

                <div class="flex-column flex-50">
                    <span class="subtitle-3 text-primary-darker">Hasta</span>
                    <app-date-picker [name]="this.VALIDITYMODULE_TO_DATE" [form]="formSuspendCaseModule">
                    </app-date-picker>
                </div>
            </div>

            <!-- Buttons -->
            <div class="flex-100 flex-row align-space-evenly-start flex-column-xs">
                <button mat-stroked-button [color]="'primary'" type="button"
                    (click)="onClickCloseSuspendCaseModuleDialog()" [disabled]="isFinalizingCaseModule">
                    CANCELAR
                </button>

                <button mat-flat-button [color]="'primary'" type="submit"
                    [disabled]="formSuspendCaseModule.invalid || isFinalizingCaseModule">
                    <span *ngIf="!(isFinalizingCaseModule); else loadingIcon">GUARDAR</span>
                </button>
            </div>
        </div>
    </form>
</ng-template>

<!-- TODO: replace when refactor suspend action -->
<!-- <ng-template #suspendCaseModuleTemplate>
    <form *ngIf="formSuspendCaseModule" class="flex-column" [formGroup]="formSuspendCaseModule" (submit)="onClickFinalizeCaseModule()">
        <div class="flex-row gap-2em flex-70">
            <div class="flex-row flex-50 gap-1em">
                <span class="subtitle-3 text-primary-darker">Módulo</span>
                <span class="subtitle-4 text-primary-darker">{{caseModuleToWork.name}}</span>
            </div>

            <div class="flex-row flex-50 gap-1em">
                <span class="subtitle-3 text-primary-darker">Convenio</span>
                <span class="subtitle-4 text-primary-darker">{{caseModuleToWork.arrangementName ?? 'Sin convenio'}}</span>
            </div>
        </div>
        <div class="flex-column flex-40 mts-2">
            <span class="subtitle-3 text-primary-darker">Último día de agenda *</span>
            <app-date-picker [name]="'lastScheduleDay'" [form]="formSuspendCaseModule"></app-date-picker>
        </div>

        <div class="flex-100 mts-3 gap-15px flex-row  align-space-evenly-start flex-row">
            <button mat-stroked-button [color]="'primary'" type="button"
                (click)="onClickCloseSuspendCaseModuleDialog()">
                CANCELAR
            </button>

            <button mat-flat-button [color]="'primary'" type="submit" [disabled]="formSuspendCaseModule.invalid || isFinalizingCaseModule">
                GUARDAR
            </button>
        </div>
    </form>
</ng-template> -->

<!-- Template para Cargar/Editar Entrega de Pedido -->
<ng-template #modifyOrderTemplate>
    <form *ngIf="formModifyOrder" class="form" [formGroup]="formModifyOrder" (ngSubmit)="onClickConfirmDelivery()">
        <!-- Tabla de insumos -->
        <div class="form__container flex-100">
            <table mat-table [dataSource]="dataSourceSupplies" class="mat-elevation-z0 order-delivery-table"
                style="table-layout: fixed; width: 100%;">
                <!-- Encabezados de columnas con agrupación -->
                <ng-container matColumnDef="header-row-group">
                    <th mat-header-cell *matHeaderCellDef [attr.colspan]="deliveringOrder ? 4 : 3"
                        class="text-center header-group">
                        SOLICITADO
                    </th>
                </ng-container>
                <ng-container matColumnDef="header-row-group-2">
                    <th mat-header-cell *matHeaderCellDef colspan="2" class="text-center header-group">
                        ENTREGADO
                    </th>
                </ng-container>

                <!-- Columna Módulo (25%) -->
                <ng-container matColumnDef="moduleColumn">
                    <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 25%;">Módulo</th>
                    <td mat-cell *matCellDef="let element; let i = index" class="text-center" style="width: 25%;">
                        <span class="module-name" style="white-space: normal; word-wrap: break-word;">{{
                            getModuleNameForDeliveryItem(i) }}</span>
                    </td>
                </ng-container>

                <!-- Columna Insumo (15%) -->
                <ng-container matColumnDef="supplyColumn">
                    <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 15%;">Insumo</th>
                    <td mat-cell *matCellDef="let element; let i = index" class="text-center" style="width: 15%;">
                        <span class="practice-name" style="white-space: normal; word-wrap: break-word;">{{
                            element.get('practice')?.value?.name }}</span>
                    </td>
                </ng-container>

                <!-- Columna Cantidad Solicitada (10%) -->
                <ng-container matColumnDef="quantityColumn">
                    <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 10%;">Cantidad</th>
                    <td mat-cell *matCellDef="let element; let i = index" class="text-center" style="width: 10%;">
                        <ng-container *ngIf="deliveringOrder; else editableQuantity">
                            <span>{{ element.get('quantityOrdered')?.value }}</span>
                            <span class="text-secondary text-input" style="font-size: 11px;">
                                {{ element.get('unit')?.value ? element.get('unit')?.value + '/s' : '' }}
                            </span>
                        </ng-container>
                        <ng-template #editableQuantity>
                            <app-number-input [name]="ITEM_QUANTITY" [form]="getItemsFormArrayDelivery(i)"
                                [money]="false" [suffix]="element.get('unit')?.value + '/s'"
                                [suffixClass]="'text-secondary'">
                            </app-number-input>
                        </ng-template>
                    </td>
                </ng-container>

                <!-- Columna Costo Unitario Solicitado (10%) -->
                <ng-container matColumnDef="priceColumn">
                    <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 10%;">Costo unitario</th>
                    <td mat-cell *matCellDef="let element; let i = index" class="text-center" style="width: 10%;">
                        <ng-container *ngIf="deliveringOrder; else editablePrice">
                            <span>{{ element.get('priceOrdered')?.value | currency:'$':'symbol':'1.2-2' }}</span>
                        </ng-container>
                        <ng-template #editablePrice>
                            <app-number-input [name]="ITEM_PRICE" [form]="getItemsFormArrayDelivery(i)" [money]="true">
                            </app-number-input>
                        </ng-template>
                    </td>
                </ng-container>

                <!-- Columna Cantidad Entregada (10%) -->
                <ng-container matColumnDef="quantityDeliveredColumn">
                    <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 10%;">Cantidad</th>
                    <td mat-cell *matCellDef="let element; let i = index" class="text-center" style="width: 10%;">
                        <app-number-input [name]="ITEM_QUANTITY_DELIVERY" [form]="getItemsFormArrayDelivery(i)"
                            [money]="false" [suffix]="element.get('unit')?.value + '/s'"
                            [suffixClass]="'text-secondary'">
                        </app-number-input>
                    </td>
                </ng-container>

                <!-- Columna Costo Unitario Entregado (10%) -->
                <ng-container matColumnDef="priceDeliveredColumn">
                    <th mat-header-cell *matHeaderCellDef class="text-center" style="width: 10%;">Costo unitario</th>
                    <td mat-cell *matCellDef="let element; let i = index" class="text-center" style="width: 10%;">
                        <app-number-input [name]="ITEM_PRICE_DELIVERY" [form]="getItemsFormArrayDelivery(i)"
                            [money]="true">
                        </app-number-input>
                    </td>
                </ng-container>


                <!-- Encabezados agrupados row -->
                <tr mat-header-row *matHeaderRowDef="deliveringOrder ? ['header-row-group', 'header-row-group-2'] : []"
                    [class.hidden]="!deliveringOrder"></tr>
                <!-- Encabezados de columnas -->
                <tr mat-header-row
                    *matHeaderRowDef="deliveringOrder ? displayedColumnsSuppliesDeliveringOrder : ['moduleColumn', 'supplyColumn', 'quantityColumn', 'priceColumn']">
                </tr>
                <!-- Filas de datos -->
                <tr mat-row
                    *matRowDef="let row; columns: deliveringOrder ? displayedColumnsSuppliesDeliveringOrder : ['moduleColumn', 'supplyColumn', 'quantityColumn', 'priceColumn'];">
                </tr>
            </table>
        </div>

        <!-- Fechas centradas -->
        <div class="flex-row align-space-around-center mts-3">
            <div class="flex-column align-center-start">
                <span class="subtitle-3 text-primary-darker mbs-0">Fecha Pautada</span>
                <app-date-picker [name]="ORDER_DATE" [form]="formModifyOrder" [placeholder]="'Fecha pautada'">
                </app-date-picker>
            </div>

            <div class="flex-column align-center-start" *ngIf="deliveringOrder">
                <span class="subtitle-3 text-primary-darker mbs-0">Fecha Entregada *</span>
                <app-date-picker [name]="ORDER_DATE_DELIVERY" [form]="formModifyOrder"
                    [placeholder]="'Fecha entregada'">
                </app-date-picker>
            </div>
        </div>

        <!-- Observaciones y Cargar remito lado a lado -->
        <div class="mys-3 flex-row space-between gap-2rem" style="align-items: flex-start;">
            <div class="flex flex-column flex-50">
                <span class="subtitle-3 text-primary-darker mbs-1">Observaciones del pedido</span>
                <app-text-area-input class="flex-100" [name]="ORDER_OBSERVATIONS" [form]="formModifyOrder"
                    [maxLength]="120">
                </app-text-area-input>
            </div>
            <div class="flex flex-column flex-50" *ngIf="deliveringOrder && editingOrder">
                <span class="subtitle-3 text-primary-darker mbs-1">Cargar remito</span>
                <file-pond #orderDeliveryPond [options]="pondOptions" (oninit)="orderDeliveryPondHandleInit()"
                    (onaddfile)="orderDeliveryPondHandleAddFile($event)"
                    (onremovefile)="orderDeliveryPondHandleRemoveFile()"
                    (onaddfilestart)="orderDeliveryPondHandleProcessFile()" allowImageResize="true"
                    allowImagePreview="true">
                </file-pond>
                <span class="text-secondary-darker" style="font-size: 12px; text-align: center;">Extensiones de archivo
                    permitidas: .pdf/.png</span>
            </div>
        </div>

        <!-- Checkbox facturar -->
        <div class="flex-row align-start-center gap-2rem">
            <app-checkbox-input
                *ngIf="deliveringOrder && editingOrder && actualOrder?.state?.id !== ORDERS_STATES.ENTREGADO"
                class="mbs-2" [labelPosition]="'after'" [form]="formModifyOrder" [label]="'Pasar a facturable'"
                [name]="IS_BILLABLE" (change)="onChangeCheckIsBillable($event)"
                (keydown.enter)="$event.preventDefault()">
            </app-checkbox-input>
        </div>

        <!-- Buttons -->
        <div class="mts-3 flex-row align-space-around-start ap-15px">
            <button mat-stroked-button [color]="'primary'" type="button" (click)="onClickCloseModifyOrderDialog()"
                [disabled]="(isLoadingUpdatingOrder$ | async) || this.loadingAddFile">
                CANCELAR
            </button>
            <button mat-flat-button [color]="'primary'" type="submit"
                [disabled]="(isLoadingUpdatingOrder$ | async) || !this.formModifyOrder.valid || this.loadingAddFile || !this.editingOrder">
                <!--|| (this.actualOrder.state.id == this.ORDERS_STATES.ENTREGADO)-->
                <span *ngIf="!(isLoadingUpdatingOrder$ | async) && !(isLoadingCreatingOrder$ | async)">
                    {{this.deliveringOrder && (this.actualOrder.state.id != this.ORDERS_STATES.ENTREGADO)
                    ? "CONFIRMAR ENTREGA"
                    : this.deliveringOrder && (this.actualOrder.state.id === this.ORDERS_STATES.ENTREGADO)
                    ? "CONFIRMAR"
                    : "MODIFICAR PEDIDO"}}
                </span>
                <mat-spinner *ngIf="(isLoadingUpdatingOrder$ | async) || (isLoadingCreatingOrder$ | async)" color="accent" diameter="20"></mat-spinner>
            </button>
        </div>
    </form>
</ng-template>  

<ng-template #loadingIcon>
    <mat-icon>
        <mat-spinner color="accent" diameter="20">
        </mat-spinner>
    </mat-icon>
</ng-template>